"use strict";

/* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
function openNav() {
  document.getElementById('page-wrapper').classList.add('mobile-menu-active');
}
/* Set the width of the side navigation to 0 and the left margin of the page content to 0, and the background color of body to white */


function closeNav() {
  document.getElementById("page-wrapper").classList.remove('mobile-menu-active');
}

function goBack() {
  $(".sidenav-panel").removeClass("sidenav-panel_open");
}

$(document).ready(function () {
  var $menu = '<div class="sidenav">\n' + '          <div class="sidenav-header">Menu\n' + '            <div class="sidenav-control"><a class="closebtn" href="javascript:void(0)" onclick="closeNav()"><span>×</span></a></div>\n' + '          </div>\n' + '          <div class="sidenav-panels">\n' + '            <div class="sidenav-panel" id="panel-menu">\n' + '               <ul>' + $("#nav-main").html() + '</ul>\n' + '            </div>\n' + '          </div>\n' + '        </div>';
  $($menu).appendTo("#page-wrapper"); //sub

  $("#panel-menu > ul > li.has-subitems").each(function (index, value) {
    var itemName = $(this).find("> a").text();
    var subItems = $(value).find(".submenu").html();
    var panel = '<div id="panel-' + index + '" class="sidenav-panel sidenav-panel-sub"><a href="javascript:void(0)" class="backbtn"><span class="custom-arrow"></span> Terug</a><div class="sidenav-panel-label">' + itemName + '</div>' + subItems + '</div>';
    $(".sidenav-panels").append(panel);
    $(this).find('.dropdown-toggle').click(function (e) {
      $("#panel-" + index).addClass("sidenav-panel_open");
    }); //subsub

    $(".sidenav-panel-sub").find("ul li.has-subitems").each(function (index1, value2) {
      var subItemName = $(this).find("> a").text();
      var subsubItems = $(value2).find(".submenu").html();
      var panel2 = '<div id="panel-sub-' + index1 + '" class="sidenav-panel sidenav-panel-sub-sub"><a href="javascript:void(0)" class="backbtn"><span class="custom-arrow"></span> Terug</a><div class="sidenav-panel-label">' + subItemName + '</div>' + subsubItems + '</div>';
      $(".sidenav-panels").append(panel2);
      $(value2).find('.dropdown-toggle').click(function (e) {
        $("#panel-sub-" + index1).addClass("sidenav-panel_open");
      });
    });
  });
  $(".backbtn").click(function () {
    $(this).parents(".sidenav-panel").toggleClass("sidenav-panel_open");
  });
  $("#panel-menu ul li a").click(function (e) {
    document.getElementById("page-wrapper").classList.remove('mobile-menu-active');
  });
});
"use strict";

$(document).ready(function () {
  matchHeight();
  handleCarousel();
  gallery();
  inViewElements();
  handleSmoothScroll();
  slider();
});
$(window).on("load", function () {
  handleFooter();
  $(window).trigger('resize');
  $(window).trigger('scroll');
});
$(window).resize(function () {
  $('.owl-carousel').trigger('refresh.owl.carousel');
});

function inViewElements() {
  $('section').one('inview', function (event, isInView) {
    if (isInView) {
      $(this).addClass('inview');
    }
  });
}

function handleSmoothScroll() {
  var sections = $('section'),
      nav = $('#panel-menu ul, #navbar, #introButton, #backToTop'),
      nav_height = $('header').outerHeight() + 1;
  $(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();
    sections.each(function () {
      var top = $(this).offset().top - nav_height,
          bottom = top + $(this).outerHeight();

      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('a').parent().removeClass('active');
        sections.removeClass('active');
        $(this).addClass('active');
        nav.find('a[href="/' + $(this).attr('id') + '"]').parent().addClass('active');
      }
    });
  });
  nav.find('a').on('click', function () {
    var $el = $(this),
        id = "#" + $el.attr('href').replace('/', ''); //set the hash in the URL

    if (history.pushState) {
      history.pushState(null, null, id);
    } else {
      location.hash = id;
    } //scoll to the element


    scrollTo($(id));
    return false;
  });
}

function scrollTo(selector) {
  var headerOffset = $('header').outerHeight();
  $('html, body').animate({
    scrollTop: selector.offset().top - headerOffset
  }, 500);
}

function matchHeight() {
  $('article .block-title').matchHeight();
}

function handleCarousel() {
  ////usps carousel
  var owlUsp = $("#owl-usp");
  owlUsp.owlCarousel({
    mouseDrag: false,
    touchDrag: true,
    slideSpeed: 800,
    paginationSpeed: 800,
    dots: false,
    nav: false,
    responsive: {
      0: {
        items: 1,
        autoWidth: false,
        autoplay: true,
        loop: true
      },
      1800: {
        items: 3,
        autoWidth: true,
        margin: 40,
        autoplay: false
      }
    }
  });
}

function slider() {
  var owlGallery = $("#owl-gallery");
  owlGallery.owlCarousel({
    items: 4,
    lazyLoad: true,
    nav: true,
    navText: ["<i class='vischmarkt49-icons vischmarkt49-icons-arrow-next'></i>", "<i class='vischmarkt49-icons vischmarkt49-icons-arrow-next'></i>"],
    dots: false,
    mouseDrag: false,
    loop: false,
    slideSpeed: 600,
    paginationSpeed: 400,
    singleItem: true,
    pagination: false,
    animateOut: 'fadeOut',
    autoplayHoverPause: true,
    autoplayTimeout: 7000,
    responsive: {
      0: {
        items: 2,
        autoplay: false
      },
      480: {
        items: 2,
        autoplay: false
      },
      768: {
        items: 2,
        autoplay: true
      },
      1024: {
        items: 3,
        autoplay: true
      },
      1600: {
        items: 4,
        autoplay: true
      }
    }
  });
}

function owlAvailability() {
  ////availability carousel
  var owlAvailability = $("#owl-availability");
  owlAvailability.owlCarousel({
    mouseDrag: false,
    touchDrag: true,
    slideSpeed: 800,
    paginationSpeed: 800,
    dots: false,
    nav: true,
    navText: ['<span class="custom-arrow custom-arrow--dark custom-arrow--left"></span>', '<span class="custom-arrow custom-arrow--dark custom-arrow--right"></span>'],
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      1024: {
        items: 3,
        margin: 60
      }
    }
  });
}

function gallery() {
  $(".slider").each(function (index, item) {
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile mfp-fade',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        // Will preload 0 - before current, and 1 after the current image
        tCounter: '%curr% van %total%' // Markup for "1 of 7" counter

      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      },
      removalDelay: 300
    });
    var galleryLength = $(item).find("a").length;

    if (galleryLength == 1) {
      $(item).addClass('one-image');
    } else if (galleryLength == 2) {
      $(item).addClass('two-image');
    } else if (galleryLength == 3) {
      $(item).addClass('three-image');
    } else if (galleryLength >= 4) {
      $(item).addClass('more');
    }
  });
}

window.onload = function () {
  progressiveImageLoader();
  progressiveBackgroundImage();
};

function progressiveBackgroundImage() {
  var placeholder = $(".bg-progressive");
  placeholder.each(function (index, element) {
    var imgUrlSmall = $(element).data('small');
    var imgUrlLarge = $(element).data('large');
    var imageWrapperSmall = $('<div class="background-image-small"></div>');
    var imageWrapperLarge = $('<div class="background-image-large"></div>');
    $(imageWrapperSmall).css("background-image", "url(" + imgUrlSmall + ")");
    $(imageWrapperLarge).css("background-image", "url(" + imgUrlLarge + ")");
    $(imageWrapperSmall).appendTo(element);
    $(imageWrapperLarge).appendTo(element);
    var img = new Image();
    img.src = imgUrlLarge;

    img.onload = function () {
      $(imageWrapperSmall).addClass('loaded');
      $(imageWrapperLarge).addClass('loaded');
    };
  });
}

function progressiveImageLoader() {
  var placeholder = $("figure.figure-progressive");
  placeholder.each(function (index, element) {
    //class
    var figureClass = $(element).attr('data-class'); //load small image

    var imageWrapperSmall = $('<img class="image-small ' + figureClass + '">');
    imageWrapperSmall.attr('src', $(element).attr('data-small')); // //load large image

    var imageWrapperLarge = $('<img class="image-large ' + figureClass + '">');
    imageWrapperLarge.attr('src', $(element).attr('data-large')).attr('srcset', $(element).attr('data-srcset')).attr('alt', $(element).attr('data-alt'));
    imageWrapperSmall.appendTo(element);
    imageWrapperLarge.appendTo(element);
    var img = new Image();
    img.src = $(element).attr('data-large'); //create image in DOM

    img.onload = function () {
      $(imageWrapperSmall).addClass('loaded ' + figureClass);
      $(imageWrapperLarge).addClass('loaded ' + figureClass);
    };
  });
}

function handleFooter() {
  $(window).resize(function () {
    var contentHeight = Math.round($("body").innerHeight());
    var windowWidth = $(window).innerWidth();
    var windowHeight = window.innerHeight;

    if (windowWidth >= 768 && contentHeight <= windowHeight) {
      $("footer").addClass("sticky");
    } else {
      $("footer").removeClass("sticky");
    }
  });
}

function handleTable() {
  $('table').addClass('table');
}
// var vueElements = vueElements || {};
//
// (function($){
// 	$(function(){
// 		//set the selector where we start
// 		var rootElem = '#custom-control';
//
// 		//only fire up when the element exists
// 		if($(rootElem).length > 0) {
//
// 			//create a vue Element
// 			vueElements.default = new Vue({
// 				el: rootElem,
// 				mounted: function () {
//
// 					var self = this;
//
// 					//show element
// 					$(rootElem).show();
//
// 					//fetch the current data
// 					self.fetchData('/items/ajax');
// 				},
// 				data: {
// 					items: {}
// 				},
// 				// define methods under the `methods` object
// 				methods: {
// 					fetchData: function(url){
// 						var self = this;
//
// 						//fallback
// 						url = url || '/items/ajax';
//
// 						//show the loader
// 						//$('body').addClass('show-loader');
//
// 						//get the data
// 						$.get(url, {}, function(data){
// 							//parse the data
// 							data = JSON.parse(data);
//
// 							//set the data
// 							self.items = data;
//
// 							//hide the loader
// 							//$('body').removeClass('show-loader');
//
// 						});
// 					},
// 					sort: function(items){
// 						return _.sortBy(items, ['day']);
// 					}
// 				}
// 			});
// 		}
// 	});
// })(jQuery);
"use strict";
"use strict";

// Get segments and store in variables(named after EE segment variables for simplicity)
var newURL = window.location.protocol + "://" + window.location.host + "/" + window.location.pathname;
var pathArray = window.location.pathname.split('/'),
    segment_4 = pathArray[4] || null,
    segment_3 = pathArray[3] || null,
    segment_2 = pathArray[2] || null;
segment_1 = pathArray[1] || null;
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//cookie plugin
!function (e) {
  if (!e.hasInitialised) {
    var t = {
      escapeRegExp: function escapeRegExp(e) {
        return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      hasClass: function hasClass(e, t) {
        var i = " ";
        return 1 === e.nodeType && (i + e.className + i).replace(/[\n\t]/g, i).indexOf(i + t + i) >= 0;
      },
      addClass: function addClass(e, t) {
        e.className += " " + t;
      },
      removeClass: function removeClass(e, t) {
        var i = new RegExp("\\b" + this.escapeRegExp(t) + "\\b");
        e.className = e.className.replace(i, "");
      },
      interpolateString: function interpolateString(e, t) {
        var i = /{{([a-z][a-z0-9\-_]*)}}/gi;
        return e.replace(i, function (e) {
          return t(arguments[1]) || "";
        });
      },
      getCookie: function getCookie(e) {
        var t = "; " + document.cookie,
            i = t.split("; " + e + "=");
        return 2 != i.length ? void 0 : i.pop().split(";").shift();
      },
      setCookie: function setCookie(e, t, i, n, o) {
        var s = new Date();
        s.setDate(s.getDate() + (i || 365));
        var r = [e + "=" + t, "expires=" + s.toUTCString(), "path=" + (o || "/")];
        n && r.push("domain=" + n), document.cookie = r.join(";");
      },
      deepExtend: function deepExtend(e, t) {
        for (var i in t) {
          t.hasOwnProperty(i) && (i in e && this.isPlainObject(e[i]) && this.isPlainObject(t[i]) ? this.deepExtend(e[i], t[i]) : e[i] = t[i]);
        }

        return e;
      },
      throttle: function throttle(e, t) {
        var i = !1;
        return function () {
          i || (e.apply(this, arguments), i = !0, setTimeout(function () {
            i = !1;
          }, t));
        };
      },
      hash: function hash(e) {
        var t,
            i,
            n,
            o = 0;
        if (0 === e.length) return o;

        for (t = 0, n = e.length; t < n; ++t) {
          i = e.charCodeAt(t), o = (o << 5) - o + i, o |= 0;
        }

        return o;
      },
      normaliseHex: function normaliseHex(e) {
        return "#" == e[0] && (e = e.substr(1)), 3 == e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), e;
      },
      getContrast: function getContrast(e) {
        e = this.normaliseHex(e);
        var t = parseInt(e.substr(0, 2), 16),
            i = parseInt(e.substr(2, 2), 16),
            n = parseInt(e.substr(4, 2), 16),
            o = (299 * t + 587 * i + 114 * n) / 1e3;
        return o >= 128 ? "#000" : "#fff";
      },
      getLuminance: function getLuminance(e) {
        var t = parseInt(this.normaliseHex(e), 16),
            i = 38,
            n = (t >> 16) + i,
            o = (t >> 8 & 255) + i,
            s = (255 & t) + i,
            r = (16777216 + 65536 * (n < 255 ? n < 1 ? 0 : n : 255) + 256 * (o < 255 ? o < 1 ? 0 : o : 255) + (s < 255 ? s < 1 ? 0 : s : 255)).toString(16).slice(1);
        return "#" + r;
      },
      isMobile: function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      },
      isPlainObject: function isPlainObject(e) {
        return "object" == _typeof(e) && null !== e && e.constructor == Object;
      }
    };
    e.status = {
      deny: "deny",
      allow: "allow",
      dismiss: "dismiss"
    }, e.transitionEnd = function () {
      var e = document.createElement("div"),
          t = {
        t: "transitionend",
        OT: "oTransitionEnd",
        msT: "MSTransitionEnd",
        MozT: "transitionend",
        WebkitT: "webkitTransitionEnd"
      };

      for (var i in t) {
        if (t.hasOwnProperty(i) && "undefined" != typeof e.style[i + "ransition"]) return t[i];
      }

      return "";
    }(), e.hasTransition = !!e.transitionEnd;
    var i = Object.keys(e.status).map(t.escapeRegExp);
    e.customStyles = {}, e.Popup = function () {
      function n() {
        this.initialise.apply(this, arguments);
      }

      function o(e) {
        this.openingTimeout = null, t.removeClass(e, "cc-invisible");
      }

      function s(t) {
        t.style.display = "none", t.removeEventListener(e.transitionEnd, this.afterTransition), this.afterTransition = null;
      }

      function r() {
        var t = this.options.onInitialise.bind(this);
        if (!window.navigator.cookieEnabled) return t(e.status.deny), !0;
        if (window.CookiesOK || window.navigator.CookiesOK) return t(e.status.allow), !0;
        var i = Object.keys(e.status),
            n = this.getStatus(),
            o = i.indexOf(n) >= 0;
        return o && t(n), o;
      }

      function a() {
        var e = this.options.position.split("-"),
            t = [];
        return e.forEach(function (e) {
          t.push("cc-" + e);
        }), t;
      }

      function c() {
        var e = this.options,
            i = "top" == e.position || "bottom" == e.position ? "banner" : "floating";
        t.isMobile() && (i = "floating");
        var n = ["cc-" + i, "cc-type-" + e.type, "cc-theme-" + e.theme];
        e["static"] && n.push("cc-static"), n.push.apply(n, a.call(this));
        p.call(this, this.options.palette);
        return this.customStyleSelector && n.push(this.customStyleSelector), n;
      }

      function l() {
        var e = {},
            i = this.options;
        i.showLink || (i.elements.link = "", i.elements.messagelink = i.elements.message), Object.keys(i.elements).forEach(function (n) {
          e[n] = t.interpolateString(i.elements[n], function (e) {
            var t = i.content[e];
            return e && "string" == typeof t && t.length ? t : "";
          });
        });
        var n = i.compliance[i.type];
        n || (n = i.compliance.info), e.compliance = t.interpolateString(n, function (t) {
          return e[t];
        });
        var o = i.layouts[i.layout];
        return o || (o = i.layouts.basic), t.interpolateString(o, function (t) {
          return e[t];
        });
      }

      function u(i) {
        var n = this.options,
            o = document.createElement("div"),
            s = n.container && 1 === n.container.nodeType ? n.container : document.body;
        o.innerHTML = i;
        var r = o.children[0];
        return r.style.display = "none", t.hasClass(r, "cc-window") && e.hasTransition && t.addClass(r, "cc-invisible"), this.onButtonClick = h.bind(this), r.addEventListener("click", this.onButtonClick), n.autoAttach && (s.firstChild ? s.insertBefore(r, s.firstChild) : s.appendChild(r)), r;
      }

      function h(n) {
        var o = n.target;

        if (t.hasClass(o, "cc-btn")) {
          var s = o.className.match(new RegExp("\\bcc-(" + i.join("|") + ")\\b")),
              r = s && s[1] || !1;
          r && (this.setStatus(r), this.close(!0));
        }

        t.hasClass(o, "cc-close") && (this.setStatus(e.status.dismiss), this.close(!0)), t.hasClass(o, "cc-revoke") && this.revokeChoice();
      }

      function p(e) {
        var i = t.hash(JSON.stringify(e)),
            n = "cc-color-override-" + i,
            o = t.isPlainObject(e);
        return this.customStyleSelector = o ? n : null, o && d(i, e, "." + n), o;
      }

      function d(i, n, o) {
        if (e.customStyles[i]) return void ++e.customStyles[i].references;
        var s = {},
            r = n.popup,
            a = n.button,
            c = n.highlight;
        r && (r.text = r.text ? r.text : t.getContrast(r.background), r.link = r.link ? r.link : r.text, s[o + ".cc-window"] = ["color: " + r.text, "background-color: " + r.background], s[o + ".cc-revoke"] = ["color: " + r.text, "background-color: " + r.background], s[o + " .cc-link," + o + " .cc-link:active," + o + " .cc-link:visited"] = ["color: " + r.link], a && (a.text = a.text ? a.text : t.getContrast(a.background), a.border = a.border ? a.border : "transparent", s[o + " .cc-btn"] = ["color: " + a.text, "border-color: " + a.border, "background-color: " + a.background], "transparent" != a.background && (s[o + " .cc-btn:hover, " + o + " .cc-btn:focus"] = ["background-color: " + v(a.background)]), c ? (c.text = c.text ? c.text : t.getContrast(c.background), c.border = c.border ? c.border : "transparent", s[o + " .cc-highlight .cc-btn:first-child"] = ["color: " + c.text, "border-color: " + c.border, "background-color: " + c.background]) : s[o + " .cc-highlight .cc-btn:first-child"] = ["color: " + r.text]));
        var l = document.createElement("style");
        document.head.appendChild(l), e.customStyles[i] = {
          references: 1,
          element: l.sheet
        };
        var u = -1;

        for (var h in s) {
          s.hasOwnProperty(h) && l.sheet.insertRule(h + "{" + s[h].join(";") + "}", ++u);
        }
      }

      function v(e) {
        return e = t.normaliseHex(e), "000000" == e ? "#222" : t.getLuminance(e);
      }

      function f(i) {
        if (t.isPlainObject(i)) {
          var n = t.hash(JSON.stringify(i)),
              o = e.customStyles[n];

          if (o && ! --o.references) {
            var s = o.element.ownerNode;
            s && s.parentNode && s.parentNode.removeChild(s), e.customStyles[n] = null;
          }
        }
      }

      function m(e, t) {
        for (var i = 0, n = e.length; i < n; ++i) {
          var o = e[i];
          if (o instanceof RegExp && o.test(t) || "string" == typeof o && o.length && o === t) return !0;
        }

        return !1;
      }

      function b() {
        var t = this.setStatus.bind(this),
            i = this.options.dismissOnTimeout;
        "number" == typeof i && i >= 0 && (this.dismissTimeout = window.setTimeout(function () {
          t(e.status.dismiss);
        }, Math.floor(i)));
        var n = this.options.dismissOnScroll;

        if ("number" == typeof n && n >= 0) {
          var o = function o(i) {
            window.pageYOffset > Math.floor(n) && (t(e.status.dismiss), window.removeEventListener("scroll", o), this.onWindowScroll = null);
          };

          this.onWindowScroll = o, window.addEventListener("scroll", o);
        }
      }

      function y() {
        if ("info" != this.options.type && (this.options.revokable = !0), t.isMobile() && (this.options.animateRevokable = !1), this.options.revokable) {
          var e = a.call(this);
          this.options.animateRevokable && e.push("cc-animate"), this.customStyleSelector && e.push(this.customStyleSelector);
          var i = this.options.revokeBtn.replace("{{classes}}", e.join(" "));
          this.revokeBtn = u.call(this, i);
          var n = this.revokeBtn;

          if (this.options.animateRevokable) {
            var o = t.throttle(function (e) {
              var i = !1,
                  o = 20,
                  s = window.innerHeight - 20;
              t.hasClass(n, "cc-top") && e.clientY < o && (i = !0), t.hasClass(n, "cc-bottom") && e.clientY > s && (i = !0), i ? t.hasClass(n, "cc-active") || t.addClass(n, "cc-active") : t.hasClass(n, "cc-active") && t.removeClass(n, "cc-active");
            }, 200);
            this.onMouseMove = o, window.addEventListener("mousemove", o);
          }
        }
      }

      var g = {
        enabled: !0,
        container: null,
        cookie: {
          name: "cookieconsent_status",
          path: "/",
          domain: "",
          expiryDays: 365
        },
        onPopupOpen: function onPopupOpen() {},
        onPopupClose: function onPopupClose() {},
        onInitialise: function onInitialise(e) {},
        onStatusChange: function onStatusChange(e, t) {},
        onRevokeChoice: function onRevokeChoice() {},
        content: {
          header: "Cookies used on the website!",
          message: "This website uses cookies to ensure you get the best experience on our website.",
          dismiss: "Got it!",
          allow: "Allow cookies",
          deny: "Decline",
          link: "Learn more",
          href: "http://cookiesandyou.com",
          close: "&#x274c;"
        },
        elements: {
          header: '<span class="cc-header">{{header}}</span>&nbsp;',
          message: '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
          messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span>',
          dismiss: '<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',
          allow: '<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',
          deny: '<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
          link: '<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',
          close: '<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'
        },
        window: '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',
        revokeBtn: '<div class="cc-revoke {{classes}}">Cookie Policy</div>',
        compliance: {
          info: '<div class="cc-compliance">{{dismiss}}</div>',
          "opt-in": '<div class="cc-compliance cc-highlight">{{dismiss}}{{allow}}</div>',
          "opt-out": '<div class="cc-compliance cc-highlight">{{deny}}{{dismiss}}</div>'
        },
        type: "info",
        layouts: {
          basic: "{{messagelink}}{{compliance}}",
          "basic-close": "{{messagelink}}{{compliance}}{{close}}",
          "basic-header": "{{header}}{{message}}{{link}}{{compliance}}"
        },
        layout: "basic",
        position: "bottom",
        theme: "block",
        "static": !1,
        palette: null,
        revokable: !1,
        animateRevokable: !0,
        showLink: !0,
        dismissOnScroll: !1,
        dismissOnTimeout: !1,
        autoOpen: !0,
        autoAttach: !0,
        whitelistPage: [],
        blacklistPage: [],
        overrideHTML: null
      };
      return n.prototype.initialise = function (e) {
        this.options && this.destroy(), t.deepExtend(this.options = {}, g), t.isPlainObject(e) && t.deepExtend(this.options, e), r.call(this) && (this.options.enabled = !1), m(this.options.blacklistPage, location.pathname) && (this.options.enabled = !1), m(this.options.whitelistPage, location.pathname) && (this.options.enabled = !0);
        var i = this.options.window.replace("{{classes}}", c.call(this).join(" ")).replace("{{children}}", l.call(this)),
            n = this.options.overrideHTML;

        if ("string" == typeof n && n.length && (i = n), this.options["static"]) {
          var o = u.call(this, '<div class="cc-grower">' + i + "</div>");
          o.style.display = "", this.element = o.firstChild, this.element.style.display = "none", t.addClass(this.element, "cc-invisible");
        } else this.element = u.call(this, i);

        b.call(this), y.call(this), this.options.autoOpen && this.autoOpen();
      }, n.prototype.destroy = function () {
        this.onButtonClick && this.element && (this.element.removeEventListener("click", this.onButtonClick), this.onButtonClick = null), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = null), this.onWindowScroll && (window.removeEventListener("scroll", this.onWindowScroll), this.onWindowScroll = null), this.onMouseMove && (window.removeEventListener("mousemove", this.onMouseMove), this.onMouseMove = null), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.revokeBtn && this.revokeBtn.parentNode && this.revokeBtn.parentNode.removeChild(this.revokeBtn), this.revokeBtn = null, f(this.options.palette), this.options = null;
      }, n.prototype.open = function (t) {
        if (this.element) return this.isOpen() || (e.hasTransition ? this.fadeIn() : this.element.style.display = "", this.options.revokable && this.toggleRevokeButton(), this.options.onPopupOpen.call(this)), this;
      }, n.prototype.close = function (t) {
        if (this.element) return this.isOpen() && (e.hasTransition ? this.fadeOut() : this.element.style.display = "none", t && this.options.revokable && this.toggleRevokeButton(!0), this.options.onPopupClose.call(this)), this;
      }, n.prototype.fadeIn = function () {
        var i = this.element;

        if (e.hasTransition && i && (this.afterTransition && s.call(this, i), t.hasClass(i, "cc-invisible"))) {
          if (i.style.display = "", this.options["static"]) {
            var n = this.element.clientHeight;
            this.element.parentNode.style.maxHeight = n + "px";
          }

          var r = 20;
          this.openingTimeout = setTimeout(o.bind(this, i), r);
        }
      }, n.prototype.fadeOut = function () {
        var i = this.element;
        e.hasTransition && i && (this.openingTimeout && (clearTimeout(this.openingTimeout), o.bind(this, i)), t.hasClass(i, "cc-invisible") || (this.options["static"] && (this.element.parentNode.style.maxHeight = ""), this.afterTransition = s.bind(this, i), i.addEventListener(e.transitionEnd, this.afterTransition), t.addClass(i, "cc-invisible")));
      }, n.prototype.isOpen = function () {
        return this.element && "" == this.element.style.display && (!e.hasTransition || !t.hasClass(this.element, "cc-invisible"));
      }, n.prototype.toggleRevokeButton = function (e) {
        this.revokeBtn && (this.revokeBtn.style.display = e ? "" : "none");
      }, n.prototype.revokeChoice = function (e) {
        this.options.enabled = !0, this.clearStatus(), this.options.onRevokeChoice.call(this), e || this.autoOpen();
      }, n.prototype.hasAnswered = function (t) {
        return Object.keys(e.status).indexOf(this.getStatus()) >= 0;
      }, n.prototype.hasConsented = function (t) {
        var i = this.getStatus();
        return i == e.status.allow || i == e.status.dismiss;
      }, n.prototype.autoOpen = function (e) {
        !this.hasAnswered() && this.options.enabled && this.open();
      }, n.prototype.setStatus = function (i) {
        var n = this.options.cookie,
            o = t.getCookie(n.name),
            s = Object.keys(e.status).indexOf(o) >= 0;
        Object.keys(e.status).indexOf(i) >= 0 ? (t.setCookie(n.name, i, n.expiryDays, n.domain, n.path), this.options.onStatusChange.call(this, i, s)) : this.clearStatus();
      }, n.prototype.getStatus = function () {
        return t.getCookie(this.options.cookie.name);
      }, n.prototype.clearStatus = function () {
        var e = this.options.cookie;
        t.setCookie(e.name, "", -1, e.domain, e.path);
      }, n;
    }(), e.Location = function () {
      function e(e) {
        t.deepExtend(this.options = {}, s), t.isPlainObject(e) && t.deepExtend(this.options, e), this.currentServiceIndex = -1;
      }

      function i(e, t, i) {
        var n,
            o = document.createElement("script");
        o.type = "text/" + (e.type || "javascript"), o.src = e.src || e, o.async = !1, o.onreadystatechange = o.onload = function () {
          var e = o.readyState;
          clearTimeout(n), t.done || e && !/loaded|complete/.test(e) || (t.done = !0, t(), o.onreadystatechange = o.onload = null);
        }, document.body.appendChild(o), n = setTimeout(function () {
          t.done = !0, t(), o.onreadystatechange = o.onload = null;
        }, i);
      }

      function n(e, t, i, n, o) {
        var s = new (window.XMLHttpRequest || window.ActiveXObject)("MSXML2.XMLHTTP.3.0");
        if (s.open(n ? "POST" : "GET", e, 1), s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), s.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), Array.isArray(o)) for (var r = 0, a = o.length; r < a; ++r) {
          var c = o[r].split(":", 2);
          s.setRequestHeader(c[0].replace(/^\s+|\s+$/g, ""), c[1].replace(/^\s+|\s+$/g, ""));
        }
        "function" == typeof t && (s.onreadystatechange = function () {
          s.readyState > 3 && t(s);
        }), s.send(n);
      }

      function o(e) {
        return new Error("Error [" + (e.code || "UNKNOWN") + "]: " + e.error);
      }

      var s = {
        timeout: 5e3,
        services: ["freegeoip", "ipinfo", "maxmind"],
        serviceDefinitions: {
          freegeoip: function freegeoip() {
            return {
              url: "//freegeoip.net/json/?callback={callback}",
              isScript: !0,
              callback: function callback(e, t) {
                try {
                  var i = JSON.parse(t);
                  return i.error ? o(i) : {
                    code: i.country_code
                  };
                } catch (n) {
                  return o({
                    error: "Invalid response (" + n + ")"
                  });
                }
              }
            };
          },
          ipinfo: function ipinfo() {
            return {
              url: "//ipinfo.io",
              headers: ["Accept: application/json"],
              callback: function callback(e, t) {
                try {
                  var i = JSON.parse(t);
                  return i.error ? o(i) : {
                    code: i.country
                  };
                } catch (n) {
                  return o({
                    error: "Invalid response (" + n + ")"
                  });
                }
              }
            };
          },
          ipinfodb: function ipinfodb(e) {
            return {
              url: "//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",
              isScript: !0,
              callback: function callback(e, t) {
                try {
                  var i = JSON.parse(t);
                  return "ERROR" == i.statusCode ? o({
                    error: i.statusMessage
                  }) : {
                    code: i.countryCode
                  };
                } catch (n) {
                  return o({
                    error: "Invalid response (" + n + ")"
                  });
                }
              }
            };
          },
          maxmind: function maxmind() {
            return {
              url: "//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",
              isScript: !0,
              callback: function callback(e) {
                return window.geoip2 ? void geoip2.country(function (t) {
                  try {
                    e({
                      code: t.country.iso_code
                    });
                  } catch (i) {
                    e(o(i));
                  }
                }, function (t) {
                  e(o(t));
                }) : void e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"));
              }
            };
          }
        }
      };
      return e.prototype.getNextService = function () {
        var e;

        do {
          e = this.getServiceByIdx(++this.currentServiceIndex);
        } while (this.currentServiceIndex < this.options.services.length && !e);

        return e;
      }, e.prototype.getServiceByIdx = function (e) {
        var i = this.options.services[e];

        if ("function" == typeof i) {
          var n = i();
          return n.name && t.deepExtend(n, this.options.serviceDefinitions[n.name](n)), n;
        }

        return "string" == typeof i ? this.options.serviceDefinitions[i]() : t.isPlainObject(i) ? this.options.serviceDefinitions[i.name](i) : null;
      }, e.prototype.locate = function (e, t) {
        var i = this.getNextService();
        return i ? (this.callbackComplete = e, this.callbackError = t, void this.runService(i, this.runNextServiceOnError.bind(this))) : void t(new Error("No services to run"));
      }, e.prototype.setupUrl = function (e) {
        var t = this.getCurrentServiceOpts();
        return e.url.replace(/\{(.*?)\}/g, function (i, n) {
          if ("callback" === n) {
            var o = "callback" + Date.now();
            return window[o] = function (t) {
              e.__JSONP_DATA = JSON.stringify(t);
            }, o;
          }

          if (n in t.interpolateUrl) return t.interpolateUrl[n];
        });
      }, e.prototype.runService = function (e, t) {
        var o = this;

        if (e && e.url && e.callback) {
          var s = e.isScript ? i : n,
              r = this.setupUrl(e);
          s(r, function (i) {
            var n = i ? i.responseText : "";
            e.__JSONP_DATA && (n = e.__JSONP_DATA, delete e.__JSONP_DATA), o.runServiceCallback.call(o, t, e, n);
          }, this.options.timeout, e.data, e.headers);
        }
      }, e.prototype.runServiceCallback = function (e, t, i) {
        var n = this,
            o = function o(t) {
          s || n.onServiceResult.call(n, e, t);
        },
            s = t.callback(o, i);

        s && this.onServiceResult.call(this, e, s);
      }, e.prototype.onServiceResult = function (e, t) {
        t instanceof Error || t && t.error ? e.call(this, t, null) : e.call(this, null, t);
      }, e.prototype.runNextServiceOnError = function (e, t) {
        if (e) {
          this.logError(e);
          var i = this.getNextService();
          i ? this.runService(i, this.runNextServiceOnError.bind(this)) : this.completeService.call(this, this.callbackError, new Error("All services failed"));
        } else this.completeService.call(this, this.callbackComplete, t);
      }, e.prototype.getCurrentServiceOpts = function () {
        var e = this.options.services[this.currentServiceIndex];
        return "string" == typeof e ? {
          name: e
        } : "function" == typeof e ? e() : t.isPlainObject(e) ? e : {};
      }, e.prototype.completeService = function (e, t) {
        this.currentServiceIndex = -1, e && e(t);
      }, e.prototype.logError = function (e) {
        var t = this.currentServiceIndex,
            i = this.getServiceByIdx(t);
        console.error("The service[" + t + "] (" + i.url + ") responded with the following error", e);
      }, e;
    }(), e.Law = function () {
      function e(e) {
        this.initialise.apply(this, arguments);
      }

      var i = {
        regionalLaw: !0,
        hasLaw: ["AT", "BE", "BG", "HR", "CZ", "CY", "DK", "EE", "FI", "FR", "DE", "EL", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "SK", "SI", "ES", "SE", "GB", "UK"],
        revokable: ["HR", "CY", "DK", "EE", "FR", "DE", "LV", "LT", "NL", "PT", "ES"],
        explicitAction: ["HR", "IT", "ES"]
      };
      return e.prototype.initialise = function (e) {
        t.deepExtend(this.options = {}, i), t.isPlainObject(e) && t.deepExtend(this.options, e);
      }, e.prototype.get = function (e) {
        var t = this.options;
        return {
          hasLaw: t.hasLaw.indexOf(e) >= 0,
          revokable: t.revokable.indexOf(e) >= 0,
          explicitAction: t.explicitAction.indexOf(e) >= 0
        };
      }, e.prototype.applyLaw = function (e, t) {
        var i = this.get(t);
        return i.hasLaw || (e.enabled = !1), this.options.regionalLaw && (i.revokable && (e.revokable = !0), i.explicitAction && (e.dismissOnScroll = !1, e.dismissOnTimeout = !1)), e;
      }, e;
    }(), e.initialise = function (t, i, n) {
      var o = new e.Law(t.law);
      i || (i = function i() {}), n || (n = function n() {}), e.getCountryCode(t, function (n) {
        delete t.law, delete t.location, n.code && (t = o.applyLaw(t, n.code)), i(new e.Popup(t));
      }, function (i) {
        delete t.law, delete t.location, n(i, new e.Popup(t));
      });
    }, e.getCountryCode = function (t, i, n) {
      if (t.law && t.law.countryCode) return void i({
        code: t.law.countryCode
      });

      if (t.location) {
        var o = new e.Location(t.location);
        return void o.locate(function (e) {
          i(e || {});
        }, n);
      }

      i({});
    }, e.utils = t, e.hasInitialised = !0, window.cookieconsent = e;
  }
}(window.cookieconsent || {});
"use strict";

//aanroep van de cookie plugin
window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: "#ffffff",
        text: "#182026"
      },
      button: {
        background: "#eaa748"
      }
    },
    position: "bottom-right",
    type: "opt-in",
    content: {
      message: "Deze website maakt gebruik van cookies om ervoor te zorgen dat u de beste ervaring op onze website krijgt.",
      dismiss: "Sluiten",
      allow: "Akkoord",
      link: "Lees verder",
      href: location.protocol + "//" + location.hostname + "/cookies"
    },
    onInitialise: function onInitialise(status) {
      var type = this.options.type;
      var didConsent = this.hasConsented();

      if (type == 'opt-in' && didConsent) {
        $(document).trigger('cookie-enabled');
      }

      if (type == 'opt-out' && !didConsent) {
        $(document).trigger('cookie-disabled');
      }
    },
    onStatusChange: function onStatusChange(status, chosenBefore) {
      var type = this.options.type;
      var didConsent = this.hasConsented();

      if (type == 'opt-in' && didConsent) {
        $(document).trigger('cookie-enabled');
      }

      if (type == 'opt-out' && !didConsent) {
        $(document).trigger('cookie-disabled');
      }
    },
    onRevokeChoice: function onRevokeChoice() {
      var type = this.options.type;

      if (type == 'opt-in') {
        $(document).trigger('cookie-disabled');
      }

      if (type == 'opt-out') {
        $(document).trigger('cookie-enabled');
      }
    }
  });
});
"use strict";

(function ($) {
  $(function () {//place here your code
  });
})(jQuery);
"use strict";

(function ($) {
  $.fn.validationEngineLanguage = function () {};

  $.validationEngineLanguage = {
    newLang: function newLang() {
      $.validationEngineLanguage.allRules = {
        "required": {
          // Add your regex rules here, you can take telephone as an example
          "regex": "geen",
          "alertText": "* Dit veld is verplicht",
          "alertTextCheckboxMultiple": "* Selecteer a.u.b. een optie",
          "alertTextCheckboxe": "* Dit selectievakje is verplicht"
        },
        "requiredInFunction": {
          "func": function func(field, rules, i, options) {
            return field.val() == "test" ? true : false;
          },
          "alertText": "* Velden moeten gelijk zijn"
        },
        "minSize": {
          "regex": "none",
          "alertText": "* Minimaal ",
          "alertText2": " karakters toegestaan"
        },
        "maxSize": {
          "regex": "none",
          "alertText": "* Maximaal ",
          "alertText2": " karakters toegestaan"
        },
        "groupRequired": {
          "regex": "none",
          "alertText": "* Vul één van de volgende velden in"
        },
        "min": {
          "regex": "none",
          "alertText": "* Minimale waarde is "
        },
        "max": {
          "regex": "none",
          "alertText": "* Maximale waarde is "
        },
        "past": {
          "regex": "none",
          "alertText": "* Datum voorafgaand aan "
        },
        "future": {
          "regex": "none",
          "alertText": "* Datum na "
        },
        "maxCheckbox": {
          "regex": "none",
          "alertText": "* Toegestane aantal vinkjes overschreden"
        },
        "minCheckbox": {
          "regex": "none",
          "alertText": "* Selecteer a.u.b. ",
          "alertText2": " opties"
        },
        "equals": {
          "regex": "none",
          "alertText": "* Velden komen niet overeen"
        },
        "creditCard": {
          "regex": "none",
          "alertText": "* Ongeldige credit card nummer"
        },
        "phone": {
          // credit: jquery.h5validate.js / orefalo
          "regex": /^([\+][0-9]{1,3}([ \.\-])?)?([\(][0-9]{1,6}[\)])?([0-9 \.\-]{1,32})(([A-Za-z \:]{1,11})?[0-9]{1,4}?)$/,
          "alertText": "* Ongeldig telefoonnummer"
        },
        "email": {
          // Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/email_address_validation/
          // Replaced incredible long regex with shorter and working one! :)
          //	                "regex": /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
          "regex": /^[a-z0-9]+[a-z0-9._%+-]*@(?:[a-z0-9-]+\.)+[a-z]{2,6}$/i,
          "alertText": "* Ongeldig emailadres"
        },
        "integer": {
          "regex": /^[\-\+]?\d+$/,
          "alertText": "* Ongeldig geheel getal"
        },
        "number": {
          // Number, including positive, negative, and floating decimal. credit: orefalo
          "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
          "alertText": "* Ongeldig komma getal"
        },
        "date": {
          "regex": /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
          "alertText": "* Ongeldige datum, formaat moet DD-MM-JJJJ zijn"
        },
        "ipv4": {
          "regex": /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
          "alertText": "* Ongeldig IP-adres"
        },
        "url": {
          "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
          "alertText": "* Ongeldige URL"
        },
        "onlyNumberSp": {
          "regex": /^[0-9\ ]+$/,
          "alertText": "* Alleen cijfers"
        },
        "onlyLetterSp": {
          "regex": /^[a-zA-Z\ \']+$/,
          "alertText": "* Alleen leestekens"
        },
        "onlyLetterNumber": {
          "regex": /^[0-9a-zA-Z]+$/,
          "alertText": "* Geen vreemde tekens toegestaan"
        },
        // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
        "ajaxUserCall": {
          "url": "ajaxValidateFieldUser",
          // you may want to pass extra data on the ajax call
          "extraData": "name=eric",
          "alertText": "* Deze gebruiker bestaat al",
          "alertTextLoad": "* Bezig met valideren, even geduld aub"
        },
        "ajaxNameCall": {
          // remote json service location
          "url": "ajaxValidateFieldName",
          // error
          "alertText": "* Deze naam bestaat al",
          // if you provide an "alertTextOk", it will show as a green prompt when the field validates
          "alertTextOk": "* Deze naam is beschikbaar",
          // speaks by itself
          "alertTextLoad": "* Bezig met valideren, even geduld aub"
        },
        "validate2fields": {
          "alertText": "* Voer aub HELLO in"
        }
      };
    }
  };
  $.validationEngineLanguage.newLang();
})(jQuery);
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Forms JS Validation.js
 * http://reinos.nl/expressionengine/forms-js-validation
 *
 * Copyright 2017, Rein de Vries
 * Released under the  License.
 */

/*
 * Inline Form Validation Engine 2.6.2, jQuery plugin
 *
 * Copyright(c) 2010, Cedric Dugas
 * http://www.position-absolute.com
 *
 * 2.0 Rewrite by Olivier Refalo
 * http://www.crionics.com
 *
 * Form validation engine allowing custom regex rules to be added.
 * Licensed under the MIT License
 */
(function ($) {
  "use strict";

  var methods = {
    /**
     * Kind of the constructor, called before any action
     * @param {Map} user options
     */
    init: function init(options) {
      var form = this;

      if (!form.data('jqv') || form.data('jqv') == null) {
        options = methods._saveOptions(form, options); // bind all formError elements to close on click

        $(document).on("click", ".formError", function () {
          $(this).fadeOut(150, function () {
            // remove prompt once invisible
            $(this).closest('.formError').remove();
          });
        });
      }

      return this;
    },

    /**
     * Attachs jQuery.validationEngine to form.submit and field.blur events
     * Takes an optional params: a list of options
     * ie. jQuery("#formID1").validationEngine('attach', {promptPosition : "centerRight"});
     */
    attach: function attach(userOptions) {
      var form = this;
      var options;
      if (userOptions) options = methods._saveOptions(form, userOptions);else options = form.data('jqv');
      options.validateAttribute = form.find("[data-validation-engine*=validate]").length ? "data-validation-engine" : "class";

      if (options.binded) {
        // delegate fields
        form.on(options.validationEventTrigger, "[" + options.validateAttribute + "*=validate]:not([type=checkbox]):not([type=radio]):not(.datepicker)", methods._onFieldEvent);
        form.on("click", "[" + options.validateAttribute + "*=validate][type=checkbox],[" + options.validateAttribute + "*=validate][type=radio]", methods._onFieldEvent);
        form.on(options.validationEventTrigger, "[" + options.validateAttribute + "*=validate][class*=datepicker]", {
          "delay": 300
        }, methods._onFieldEvent);
      }

      if (options.autoPositionUpdate) {
        $(window).bind("resize", {
          "noAnimation": true,
          "formElem": form
        }, methods.updatePromptsPosition);
      }

      form.on("click", "a[data-validation-engine-skip], a[class*='validate-skip'], button[data-validation-engine-skip], button[class*='validate-skip'], input[data-validation-engine-skip], input[class*='validate-skip']", methods._submitButtonClick);
      form.removeData('jqv_submitButton'); // bind form.submit

      form.on("submit", methods._onSubmitEvent);
      return this;
    },

    /**
     * Unregisters any bindings that may point to jQuery.validaitonEngine
     */
    detach: function detach() {
      var form = this;
      var options = form.data('jqv'); // unbind fields

      form.off(options.validationEventTrigger, "[" + options.validateAttribute + "*=validate]:not([type=checkbox]):not([type=radio]):not(.datepicker)", methods._onFieldEvent);
      form.off("click", "[" + options.validateAttribute + "*=validate][type=checkbox],[" + options.validateAttribute + "*=validate][type=radio]", methods._onFieldEvent);
      form.off(options.validationEventTrigger, "[" + options.validateAttribute + "*=validate][class*=datepicker]", methods._onFieldEvent); // unbind form.submit

      form.off("submit", methods._onSubmitEvent);
      form.removeData('jqv');
      form.off("click", "a[data-validation-engine-skip], a[class*='validate-skip'], button[data-validation-engine-skip], button[class*='validate-skip'], input[data-validation-engine-skip], input[class*='validate-skip']", methods._submitButtonClick);
      form.removeData('jqv_submitButton');
      if (options.autoPositionUpdate) $(window).off("resize", methods.updatePromptsPosition);
      return this;
    },

    /**
     * Validates either a form or a list of fields, shows prompts accordingly.
     * Note: There is no ajax form validation with this method, only field ajax validation are evaluated
     *
     * @return true if the form validates, false if it fails
     */
    validate: function validate(userOptions) {
      var element = $(this);
      var valid = null;
      var options;

      if (element.is("form") || element.hasClass("validationEngineContainer")) {
        if (element.hasClass('validating')) {
          // form is already validating.
          // Should abort old validation and start new one. I don't know how to implement it.
          return false;
        } else {
          element.addClass('validating');
          if (userOptions) options = methods._saveOptions(element, userOptions);else options = element.data('jqv');

          var valid = methods._validateFields(this); // If the form doesn't validate, clear the 'validating' class before the user has a chance to submit again


          setTimeout(function () {
            element.removeClass('validating');
          }, 100);

          if (valid && options.onSuccess) {
            options.onSuccess();
          } else if (!valid && options.onFailure) {
            options.onFailure();
          }
        }
      } else if (element.is('form') || element.hasClass('validationEngineContainer')) {
        element.removeClass('validating');
      } else {
        // field validation
        var form = element.closest('form, .validationEngineContainer');
        options = form.data('jqv') ? form.data('jqv') : $.validationEngine.defaults;
        valid = methods._validateField(element, options);
        if (valid && options.onFieldSuccess) options.onFieldSuccess();else if (options.onFieldFailure && options.InvalidFields.length > 0) {
          options.onFieldFailure();
        }
        return !valid;
      }

      if (options.onValidationComplete) {
        // !! ensures that an undefined return is interpreted as return false but allows a onValidationComplete() to possibly return true and have form continue processing
        return !!options.onValidationComplete(form, valid);
      }

      return valid;
    },

    /**
     *  Redraw prompts position, useful when you change the DOM state when validating
     */
    updatePromptsPosition: function updatePromptsPosition(event) {
      if (event && this == window) {
        var form = event.data.formElem;
        var noAnimation = event.data.noAnimation;
      } else var form = $(this.closest('form, .validationEngineContainer'));

      var options = form.data('jqv'); // No option, take default one

      if (!options) options = methods._saveOptions(form, options);
      form.find('[' + options.validateAttribute + '*=validate]').not(":disabled").each(function () {
        var field = $(this);
        if (options.prettySelect && field.is(":hidden")) field = form.find("#" + options.usePrefix + field.attr('id') + options.useSuffix);

        var prompt = methods._getPrompt(field);

        var promptText = $(prompt).find(".formErrorContent").html();
        if (prompt) methods._updatePrompt(field, $(prompt), promptText, undefined, false, options, noAnimation);
      });
      return this;
    },

    /**
     * Displays a prompt on a element.
     * Note that the element needs an id!
     *
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {String} possible values topLeft, topRight, bottomLeft, centerRight, bottomRight
     */
    showPrompt: function showPrompt(promptText, type, promptPosition, showArrow) {
      var form = this.closest('form, .validationEngineContainer');
      var options = form.data('jqv'); // No option, take default one

      if (!options) options = methods._saveOptions(this, options);
      if (promptPosition) options.promptPosition = promptPosition;
      options.showArrow = showArrow == true;

      methods._showPrompt(this, promptText, type, false, options);

      return this;
    },

    /**
     * Closes form error prompts, CAN be invidual
     */
    hide: function hide() {
      var form = $(this).closest('form, .validationEngineContainer');
      var options = form.data('jqv'); // No option, take default one

      if (!options) options = methods._saveOptions(form, options);
      var fadeDuration = options && options.fadeDuration ? options.fadeDuration : 0.3;
      var closingtag;

      if (form.is("form") || form.hasClass("validationEngineContainer")) {
        closingtag = "parentForm" + methods._getClassName($(form).attr("id"));
      } else {
        closingtag = methods._getClassName($(form).attr("id")) + "formError";
      }

      $('.' + closingtag).fadeTo(fadeDuration, 0, function () {
        $(this).closest('.formError').remove();
      });
      return this;
    },

    /**
     * Closes all error prompts on the page
     */
    hideAll: function hideAll() {
      var form = this;
      var options = form.data('jqv');
      var duration = options ? options.fadeDuration : 300;
      $('.formError').fadeTo(duration, 0, function () {
        $(this).closest('.formError').remove();
      });
      return this;
    },

    /**
     * Typically called when user exists a field using tab or a mouse click, triggers a field
     * validation
     */
    _onFieldEvent: function _onFieldEvent(event) {
      var field = $(this);
      var form = field.closest('form, .validationEngineContainer');
      var options = form.data('jqv'); // No option, take default one

      if (!options) options = methods._saveOptions(form, options);
      options.eventTrigger = "field";

      if (options.notEmpty == true) {
        if (field.val().length > 0) {
          // validate the current field
          window.setTimeout(function () {
            methods._validateField(field, options);
          }, event.data ? event.data.delay : 0);
        }
      } else {
        // validate the current field
        window.setTimeout(function () {
          methods._validateField(field, options);
        }, event.data ? event.data.delay : 0);
      }
    },

    /**
     * Called when the form is submited, shows prompts accordingly
     *
     * @param {jqObject}
     *            form
     * @return false if form submission needs to be cancelled
     */
    _onSubmitEvent: function _onSubmitEvent() {
      var form = $(this);
      var options = form.data('jqv'); //check if it is trigger from skipped button

      if (form.data("jqv_submitButton")) {
        var submitButton = $("#" + form.data("jqv_submitButton"));

        if (submitButton) {
          if (submitButton.length > 0) {
            if (submitButton.hasClass("validate-skip") || submitButton.attr("data-validation-engine-skip") == "true") return true;
          }
        }
      }

      options.eventTrigger = "submit"; // validate each field
      // (- skip field ajax validation, not necessary IF we will perform an ajax form validation)

      var r = methods._validateFields(form);

      if (r && options.ajaxFormValidation) {
        methods._validateFormWithAjax(form, options); // cancel form auto-submission - process with async call onAjaxFormComplete


        return false;
      }

      if (options.onValidationComplete) {
        // !! ensures that an undefined return is interpreted as return false but allows a onValidationComplete() to possibly return true and have form continue processing
        return !!options.onValidationComplete(form, r);
      }

      return r;
    },

    /**
     * Return true if the ajax field validations passed so far
     * @param {Object} options
     * @return true, is all ajax validation passed so far (remember ajax is async)
     */
    _checkAjaxStatus: function _checkAjaxStatus(options) {
      var status = true;
      $.each(options.ajaxValidCache, function (key, value) {
        if (!value) {
          status = false; // break the each

          return false;
        }
      });
      return status;
    },

    /**
     * Return true if the ajax field is validated
     * @param {String} fieldid
     * @param {Object} options
     * @return true, if validation passed, false if false or doesn't exist
     */
    _checkAjaxFieldStatus: function _checkAjaxFieldStatus(fieldid, options) {
      return options.ajaxValidCache[fieldid] == true;
    },

    /**
     * Validates form fields, shows prompts accordingly
     *
     * @param {jqObject}
     *            form
     * @param {skipAjaxFieldValidation}
     *            boolean - when set to true, ajax field validation is skipped, typically used when the submit button is clicked
     *
     * @return true if form is valid, false if not, undefined if ajax form validation is done
     */
    _validateFields: function _validateFields(form) {
      var options = form.data('jqv'); // this variable is set to true if an error is found

      var errorFound = false; // Trigger hook, start validation

      form.trigger("jqv.form.validating"); // first, evaluate status of non ajax fields

      var first_err = null;
      form.find('[' + options.validateAttribute + '*=validate]').not(":disabled").each(function () {
        var field = $(this);
        var names = [];

        if ($.inArray(field.attr('name'), names) < 0) {
          errorFound |= methods._validateField(field, options);
          if (errorFound && first_err == null) if (field.is(":hidden") && options.prettySelect) first_err = field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);else {
            //Check if we need to adjust what element to show the prompt on
            //and and such scroll to instead
            if (field.data('jqv-prompt-at') instanceof jQuery) {
              field = field.data('jqv-prompt-at');
            } else if (field.data('jqv-prompt-at')) {
              field = $(field.data('jqv-prompt-at'));
            }

            first_err = field;
          }
          if (options.doNotShowAllErrosOnSubmit) return false;
          names.push(field.attr('name')); //if option set, stop checking validation rules after one error is found

          if (options.showOneMessage == true && errorFound) {
            return false;
          }
        }
      }); // second, check to see if all ajax calls completed ok
      // errorFound |= !methods._checkAjaxStatus(options);
      // third, check status and scroll the container accordingly

      form.trigger("jqv.form.result", [errorFound]);

      if (errorFound) {
        if (options.scroll) {
          var destination = first_err.offset().top;
          var fixleft = first_err.offset().left; //prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)

          var positionType = options.promptPosition;
          if (typeof positionType == 'string' && positionType.indexOf(":") != -1) positionType = positionType.substring(0, positionType.indexOf(":"));

          if (positionType != "bottomRight" && positionType != "bottomLeft") {
            var prompt_err = methods._getPrompt(first_err);

            if (prompt_err) {
              destination = prompt_err.offset().top;
            }
          } // Offset the amount the page scrolls by an amount in px to accomodate fixed elements at top of page


          if (options.scrollOffset) {
            destination -= options.scrollOffset;
          } // get the position of the first error, there should be at least one, no need to check this
          //var destination = form.find(".formError:not('.greenPopup'):first").offset().top;


          if (options.isOverflown) {
            var overflowDIV = $(options.overflownDIV);
            if (!overflowDIV.length) return false;
            var scrollContainerScroll = overflowDIV.scrollTop();
            var scrollContainerPos = -parseInt(overflowDIV.offset().top);
            destination += scrollContainerScroll + scrollContainerPos - 5;
            var scrollContainer = $(options.overflownDIV).filter(":not(:animated)");
            scrollContainer.animate({
              scrollTop: destination
            }, 1100, function () {
              if (options.focusFirstField) first_err.focus();
            });
          } else {
            $("html, body").animate({
              scrollTop: destination
            }, 1100, function () {
              if (options.focusFirstField) first_err.focus();
            });
            $("html, body").animate({
              scrollLeft: fixleft
            }, 1100);
          }
        } else if (options.focusFirstField) first_err.focus();

        return false;
      }

      return true;
    },

    /**
     * This method is called to perform an ajax form validation.
     * During this process all the (field, value) pairs are sent to the server which returns a list of invalid fields or true
     *
     * @param {jqObject} form
     * @param {Map} options
     */
    _validateFormWithAjax: function _validateFormWithAjax(form, options) {
      var data = form.serialize();
      var type = options.ajaxFormValidationMethod ? options.ajaxFormValidationMethod : "GET";
      var url = options.ajaxFormValidationURL ? options.ajaxFormValidationURL : form.attr("action");
      var dataType = options.dataType ? options.dataType : "json";
      $.ajax({
        type: type,
        url: url,
        cache: false,
        dataType: dataType,
        data: data,
        form: form,
        methods: methods,
        options: options,
        beforeSend: function beforeSend() {
          return options.onBeforeAjaxFormValidation(form, options);
        },
        error: function error(data, transport) {
          if (options.onFailure) {
            options.onFailure(data, transport);
          } else {
            methods._ajaxError(data, transport);
          }
        },
        success: function success(json) {
          if (dataType == "json" && json !== true) {
            // getting to this case doesn't necessary means that the form is invalid
            // the server may return green or closing prompt actions
            // this flag helps figuring it out
            var errorInForm = false;

            for (var i = 0; i < json.length; i++) {
              var value = json[i];
              var errorFieldId = value[0];
              var errorField = $($("#" + errorFieldId)[0]); // make sure we found the element

              if (errorField.length == 1) {
                // promptText or selector
                var msg = value[2]; // if the field is valid

                if (value[1] == true) {
                  if (msg == "" || !msg) {
                    // if for some reason, status==true and error="", just close the prompt
                    methods._closePrompt(errorField);
                  } else {
                    // the field is valid, but we are displaying a green prompt
                    if (options.allrules[msg]) {
                      var txt = options.allrules[msg].alertTextOk;
                      if (txt) msg = txt;
                    }

                    if (options.showPrompts) methods._showPrompt(errorField, msg, "pass", false, options, true);
                  }
                } else {
                  // the field is invalid, show the red error prompt
                  errorInForm |= true;

                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertText;
                    if (txt) msg = txt;
                  }

                  if (options.showPrompts) methods._showPrompt(errorField, msg, "", false, options, true);
                }
              }
            }

            options.onAjaxFormComplete(!errorInForm, form, json, options);
          } else options.onAjaxFormComplete(true, form, json, options);
        }
      });
    },

    /**
     * Validates field, shows prompts accordingly
     *
     * @param {jqObject}
     *            field
     * @param {Array[String]}
     *            field's validation rules
     * @param {Map}
     *            user options
     * @return false if field is valid (It is inversed for *fields*, it return false on validate and true on errors.)
     */
    _validateField: function _validateField(field, options, skipAjaxValidation) {
      if (!field.attr("id")) {
        field.attr("id", "form-validation-field-" + $.validationEngine.fieldIdCounter);
        ++$.validationEngine.fieldIdCounter;
      }

      if (field.hasClass(options.ignoreFieldsWithClass)) return false;
      if (!options.validateNonVisibleFields && (field.is(":hidden") && !options.prettySelect || field.parent().is(":hidden"))) return false;
      var rulesParsing = field.attr(options.validateAttribute);
      var getRules = /validate\[(.*)\]/.exec(rulesParsing);
      if (!getRules) return false;
      var str = getRules[1];
      var rules = str.split(/\[|,|\]/); // true if we ran the ajax validation, tells the logic to stop messing with prompts

      var isAjaxValidator = false;
      var fieldName = field.attr("name");
      var promptText = "";
      var promptType = "";
      var required = false;
      var limitErrors = false;
      options.isError = false;
      options.showArrow = options.showArrow == true; // If the programmer wants to limit the amount of error messages per field,

      if (options.maxErrorsPerField > 0) {
        limitErrors = true;
      }

      var form = $(field.closest("form, .validationEngineContainer")); // Fix for adding spaces in the rules

      for (var i = 0; i < rules.length; i++) {
        rules[i] = rules[i].toString().replace(" ", ""); //.toString to worked on IE8
        // Remove any parsing errors

        if (rules[i] === '') {
          delete rules[i];
        }
      }

      for (var i = 0, field_errors = 0; i < rules.length; i++) {
        // If we are limiting errors, and have hit the max, break
        if (limitErrors && field_errors >= options.maxErrorsPerField) {
          // If we haven't hit a required yet, check to see if there is one in the validation rules for this
          // field and that it's index is greater or equal to our current index
          if (!required) {
            var have_required = $.inArray('required', rules);
            required = have_required != -1 && have_required >= i;
          }

          break;
        }

        var errorMsg = undefined;

        switch (rules[i]) {
          case "required":
            required = true;
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._required);
            break;

          case "custom":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._custom);
            break;

          case "groupRequired":
            // Check is its the first of group, if not, reload validation with first field
            // AND continue normal validation on present field
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            var firstOfGroup = form.find(classGroup).eq(0);

            if (firstOfGroup[0] != field[0]) {
              methods._validateField(firstOfGroup, options, skipAjaxValidation);

              options.showArrow = true;
            }

            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._groupRequired);
            if (errorMsg) required = true;
            options.showArrow = false;
            break;

          case "ajax":
            // AJAX defaults to returning it's loading message
            errorMsg = methods._ajax(field, rules, i, options);

            if (errorMsg) {
              promptType = "load";
            }

            break;

          case "minSize":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minSize);
            break;

          case "maxSize":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxSize);
            break;

          case "min":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._min);
            break;

          case "max":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._max);
            break;

          case "past":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._past);
            break;

          case "future":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._future);
            break;

          case "dateRange":
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            options.firstOfGroup = form.find(classGroup).eq(0);
            options.secondOfGroup = form.find(classGroup).eq(1); //if one entry out of the pair has value then proceed to run through validation

            if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
              errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._dateRange);
            }

            if (errorMsg) required = true;
            options.showArrow = false;
            break;

          case "dateTimeRange":
            var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
            options.firstOfGroup = form.find(classGroup).eq(0);
            options.secondOfGroup = form.find(classGroup).eq(1); //if one entry out of the pair has value then proceed to run through validation

            if (options.firstOfGroup[0].value || options.secondOfGroup[0].value) {
              errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._dateTimeRange);
            }

            if (errorMsg) required = true;
            options.showArrow = false;
            break;

          case "maxCheckbox":
            field = $(form.find("input[name='" + fieldName + "']"));
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._maxCheckbox);
            break;

          case "minCheckbox":
            field = $(form.find("input[name='" + fieldName + "']"));
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._minCheckbox);
            break;

          case "equals":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._equals);
            break;

          case "funcCall":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._funcCall);
            break;

          case "creditCard":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._creditCard);
            break;

          case "condRequired":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._condRequired);

            if (errorMsg !== undefined) {
              required = true;
            }

            break;

          case "funcCallRequired":
            errorMsg = methods._getErrorMessage(form, field, rules[i], rules, i, options, methods._funcCallRequired);

            if (errorMsg !== undefined) {
              required = true;
            }

            break;

          default:
        }

        var end_validation = false; // If we were passed back an message object, check what the status was to determine what to do

        if (_typeof(errorMsg) == "object") {
          switch (errorMsg.status) {
            case "_break":
              end_validation = true;
              break;
            // If we have an error message, set errorMsg to the error message

            case "_error":
              errorMsg = errorMsg.message;
              break;
            // If we want to throw an error, but not show a prompt, return early with true

            case "_error_no_prompt":
              return true;
              break;
            // Anything else we continue on

            default:
              break;
          }
        } //funcCallRequired, first in rules, and has error, skip anything else


        if (i == 0 && str.indexOf('funcCallRequired') == 0 && errorMsg !== undefined) {
          if (promptText != '') {
            promptText += "<br/>";
          }

          promptText += errorMsg;
          options.isError = true;
          field_errors++;
          end_validation = true;
        } // If it has been specified that validation should end now, break


        if (end_validation) {
          break;
        } // If we have a string, that means that we have an error, so add it to the error message.


        if (typeof errorMsg == 'string') {
          if (promptText != '') {
            promptText += "<br/>";
          }

          promptText += errorMsg;
          options.isError = true;
          field_errors++;
        }
      } // If the rules required is not added, an empty field is not validated
      //the 3rd condition is added so that even empty password fields should be equal
      //otherwise if one is filled and another left empty, the "equal" condition would fail
      //which does not make any sense


      if (!required && !field.val() && field.val().length < 1 && $.inArray('equals', rules) < 0) options.isError = false; // Hack for radio/checkbox group button, the validation go into the
      // first radio/checkbox of the group

      var fieldType = field.prop("type");
      var positionType = field.data("promptPosition") || options.promptPosition;

      if ((fieldType == "radio" || fieldType == "checkbox") && form.find("input[name='" + fieldName + "']").length > 1) {
        if (positionType === 'inline') {
          field = $(form.find("input[name='" + fieldName + "'][type!=hidden]:last"));
        } else {
          field = $(form.find("input[name='" + fieldName + "'][type!=hidden]:first"));
        }

        options.showArrow = options.showArrowOnRadioAndCheckbox;
      }

      if (field.is(":hidden") && options.prettySelect) {
        field = form.find("#" + options.usePrefix + methods._jqSelector(field.attr('id')) + options.useSuffix);
      }

      if (options.isError && options.showPrompts) {
        methods._showPrompt(field, promptText, promptType, false, options);
      } else {
        if (!isAjaxValidator) methods._closePrompt(field);
      }

      if (!isAjaxValidator) {
        field.trigger("jqv.field.result", [field, options.isError, promptText]);
      }
      /* Record error */


      var errindex = $.inArray(field[0], options.InvalidFields);

      if (errindex == -1) {
        if (options.isError) options.InvalidFields.push(field[0]);
      } else if (!options.isError) {
        options.InvalidFields.splice(errindex, 1);
      }

      methods._handleStatusCssClasses(field, options);
      /* run callback function for each field */


      if (options.isError && options.onFieldFailure) options.onFieldFailure(field);
      if (!options.isError && options.onFieldSuccess) options.onFieldSuccess(field);
      return options.isError;
    },

    /**
     * Handling css classes of fields indicating result of validation
     *
     * @param {jqObject}
     *            field
     * @param {Array[String]}
     *            field's validation rules
     * @private
     */
    _handleStatusCssClasses: function _handleStatusCssClasses(field, options) {
      /* remove all classes */
      if (options.addSuccessCssClassToField) field.removeClass(options.addSuccessCssClassToField);
      if (options.addFailureCssClassToField) field.removeClass(options.addFailureCssClassToField);
      /* Add classes */

      if (options.addSuccessCssClassToField && !options.isError) field.addClass(options.addSuccessCssClassToField);
      if (options.addFailureCssClassToField && options.isError) field.addClass(options.addFailureCssClassToField);
    },

    /********************
     * _getErrorMessage
     *
     * @param form
     * @param field
     * @param rule
     * @param rules
     * @param i
     * @param options
     * @param originalValidationMethod
     * @return {*}
     * @private
     */
    _getErrorMessage: function _getErrorMessage(form, field, rule, rules, i, options, originalValidationMethod) {
      // If we are using the custon validation type, build the index for the rule.
      // Otherwise if we are doing a function call, make the call and return the object
      // that is passed back.
      var rule_index = jQuery.inArray(rule, rules);

      if (rule === "custom" || rule === "funcCall" || rule === "funcCallRequired") {
        var custom_validation_type = rules[rule_index + 1];
        rule = rule + "[" + custom_validation_type + "]"; // Delete the rule from the rules array so that it doesn't try to call the
        // same rule over again

        delete rules[rule_index];
      } // Change the rule to the composite rule, if it was different from the original


      var alteredRule = rule;
      var element_classes = field.attr("data-validation-engine") ? field.attr("data-validation-engine") : field.attr("class");
      var element_classes_array = element_classes.split(" "); // Call the original validation method. If we are dealing with dates or checkboxes, also pass the form

      var errorMsg;

      if (rule == "future" || rule == "past" || rule == "maxCheckbox" || rule == "minCheckbox") {
        errorMsg = originalValidationMethod(form, field, rules, i, options);
      } else {
        errorMsg = originalValidationMethod(field, rules, i, options);
      } // If the original validation method returned an error and we have a custom error message,
      // return the custom message instead. Otherwise return the original error message.


      if (errorMsg != undefined) {
        var custom_message = methods._getCustomErrorMessage($(field), element_classes_array, alteredRule, options);

        if (custom_message) errorMsg = custom_message;
      }

      return errorMsg;
    },
    _getCustomErrorMessage: function _getCustomErrorMessage(field, classes, rule, options) {
      var custom_message = false;
      var validityProp = /^custom\[.*\]$/.test(rule) ? methods._validityProp["custom"] : methods._validityProp[rule]; // If there is a validityProp for this rule, check to see if the field has an attribute for it

      if (validityProp != undefined) {
        custom_message = field.attr("data-errormessage-" + validityProp); // If there was an error message for it, return the message

        if (custom_message != undefined) return custom_message;
      }

      custom_message = field.attr("data-errormessage"); // If there is an inline custom error message, return it

      if (custom_message != undefined) return custom_message;
      var id = '#' + field.attr("id"); // If we have custom messages for the element's id, get the message for the rule from the id.
      // Otherwise, if we have custom messages for the element's classes, use the first class message we find instead.

      if (typeof options.custom_error_messages[id] != "undefined" && typeof options.custom_error_messages[id][rule] != "undefined") {
        custom_message = options.custom_error_messages[id][rule]['message'];
      } else if (classes.length > 0) {
        for (var i = 0; i < classes.length && classes.length > 0; i++) {
          var element_class = "." + classes[i];

          if (typeof options.custom_error_messages[element_class] != "undefined" && typeof options.custom_error_messages[element_class][rule] != "undefined") {
            custom_message = options.custom_error_messages[element_class][rule]['message'];
            break;
          }
        }
      }

      if (!custom_message && typeof options.custom_error_messages[rule] != "undefined" && typeof options.custom_error_messages[rule]['message'] != "undefined") {
        custom_message = options.custom_error_messages[rule]['message'];
      }

      return custom_message;
    },
    _validityProp: {
      "required": "value-missing",
      "custom": "custom-error",
      "groupRequired": "value-missing",
      "ajax": "custom-error",
      "minSize": "range-underflow",
      "maxSize": "range-overflow",
      "min": "range-underflow",
      "max": "range-overflow",
      "past": "type-mismatch",
      "future": "type-mismatch",
      "dateRange": "type-mismatch",
      "dateTimeRange": "type-mismatch",
      "maxCheckbox": "range-overflow",
      "minCheckbox": "range-underflow",
      "equals": "pattern-mismatch",
      "funcCall": "custom-error",
      "funcCallRequired": "custom-error",
      "creditCard": "pattern-mismatch",
      "condRequired": "value-missing"
    },

    /**
     * Required validation
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @param {bool} condRequired flag when method is used for internal purpose in condRequired check
     * @return an error string if validation failed
     */
    _required: function _required(field, rules, i, options, condRequired) {
      switch (field.prop("type")) {
        case "radio":
        case "checkbox":
          // new validation style to only check dependent field
          if (condRequired) {
            if (!field.prop('checked')) {
              return options.allrules[rules[i]].alertTextCheckboxMultiple;
            }

            break;
          } // old validation style


          var form = field.closest("form, .validationEngineContainer");
          var name = field.attr("name");

          if (form.find("input[name='" + name + "']:checked").length == 0) {
            if (form.find("input[name='" + name + "']:visible").length == 1) return options.allrules[rules[i]].alertTextCheckboxe;else return options.allrules[rules[i]].alertTextCheckboxMultiple;
          }

          break;

        case "text":
        case "password":
        case "textarea":
        case "file":
        case "select-one":
        case "select-multiple":
        default:
          var field_val = $.trim(field.val());
          var dv_placeholder = $.trim(field.attr("data-validation-placeholder"));
          var placeholder = $.trim(field.attr("placeholder"));

          if (!field_val || dv_placeholder && field_val == dv_placeholder || placeholder && field_val == placeholder) {
            return options.allrules[rules[i]].alertText;
          }

          break;
      }
    },

    /**
     * Validate that 1 from the group field is required
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _groupRequired: function _groupRequired(field, rules, i, options) {
      var classGroup = "[" + options.validateAttribute + "*=" + rules[i + 1] + "]";
      var isValid = false; // Check all fields from the group

      field.closest("form, .validationEngineContainer").find(classGroup).each(function () {
        if (!methods._required($(this), rules, i, options)) {
          isValid = true;
          return false;
        }
      });

      if (!isValid) {
        return options.allrules[rules[i]].alertText;
      }
    },

    /**
     * Validate rules
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _custom: function _custom(field, rules, i, options) {
      var customRule = rules[i + 1];
      var rule = options.allrules[customRule];
      var fn;

      if (!rule) {
        alert("jqv:custom rule not found - " + customRule);
        return;
      }

      if (rule["regex"]) {
        var ex = rule.regex;

        if (!ex) {
          alert("jqv:custom regex not found - " + customRule);
          return;
        }

        var pattern = new RegExp(ex);
        if (!pattern.test(field.val())) return options.allrules[customRule].alertText;
      } else if (rule["func"]) {
        fn = rule["func"];

        if (typeof fn !== "function") {
          alert("jqv:custom parameter 'function' is no function - " + customRule);
          return;
        }

        if (!fn(field, rules, i, options)) return options.allrules[customRule].alertText;
      } else {
        alert("jqv:custom type not allowed " + customRule);
        return;
      }
    },

    /**
     * Validate custom function outside of the engine scope
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _funcCall: function _funcCall(field, rules, i, options) {
      var functionName = rules[i + 1];
      var fn;

      if (functionName.indexOf('.') > -1) {
        var namespaces = functionName.split('.');
        var scope = window;

        while (namespaces.length) {
          scope = scope[namespaces.shift()];
        }

        fn = scope;
      } else fn = window[functionName] || options.customFunctions[functionName];

      if (typeof fn == 'function') return fn(field, rules, i, options);
    },
    _funcCallRequired: function _funcCallRequired(field, rules, i, options) {
      return methods._funcCall(field, rules, i, options);
    },

    /**
     * Field match
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _equals: function _equals(field, rules, i, options) {
      var equalsField = rules[i + 1];
      if (field.val() != $("#" + equalsField).val()) return options.allrules.equals.alertText;
    },

    /**
     * Check the maximum size (in characters)
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _maxSize: function _maxSize(field, rules, i, options) {
      var max = rules[i + 1];
      var len = field.val().length;

      if (len > max) {
        var rule = options.allrules.maxSize;
        return rule.alertText + max + rule.alertText2;
      }
    },

    /**
     * Check the minimum size (in characters)
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _minSize: function _minSize(field, rules, i, options) {
      var min = rules[i + 1];
      var len = field.val().length;

      if (len < min) {
        var rule = options.allrules.minSize;
        return rule.alertText + min + rule.alertText2;
      }
    },

    /**
     * Check number minimum value
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _min: function _min(field, rules, i, options) {
      var min = parseFloat(rules[i + 1]);
      var len = parseFloat(field.val());

      if (len < min) {
        var rule = options.allrules.min;
        if (rule.alertText2) return rule.alertText + min + rule.alertText2;
        return rule.alertText + min;
      }
    },

    /**
     * Check number maximum value
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _max: function _max(field, rules, i, options) {
      var max = parseFloat(rules[i + 1]);
      var len = parseFloat(field.val());

      if (len > max) {
        var rule = options.allrules.max;
        if (rule.alertText2) return rule.alertText + max + rule.alertText2; //orefalo: to review, also do the translations

        return rule.alertText + max;
      }
    },

    /**
     * Checks date is in the past
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _past: function _past(form, field, rules, i, options) {
      var p = rules[i + 1];
      var fieldAlt = $(form.find("*[name='" + p.replace(/^#+/, '') + "']"));
      var pdate;

      if (p.toLowerCase() == "now") {
        pdate = new Date();
      } else if (undefined != fieldAlt.val()) {
        if (fieldAlt.is(":disabled")) return;
        pdate = methods._parseDate(fieldAlt.val());
      } else {
        pdate = methods._parseDate(p);
      }

      var vdate = methods._parseDate(field.val());

      if (vdate > pdate) {
        var rule = options.allrules.past;
        if (rule.alertText2) return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
        return rule.alertText + methods._dateToString(pdate);
      }
    },

    /**
     * Checks date is in the future
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _future: function _future(form, field, rules, i, options) {
      var p = rules[i + 1];
      var fieldAlt = $(form.find("*[name='" + p.replace(/^#+/, '') + "']"));
      var pdate;

      if (p.toLowerCase() == "now") {
        pdate = new Date();
      } else if (undefined != fieldAlt.val()) {
        if (fieldAlt.is(":disabled")) return;
        pdate = methods._parseDate(fieldAlt.val());
      } else {
        pdate = methods._parseDate(p);
      }

      var vdate = methods._parseDate(field.val());

      if (vdate < pdate) {
        var rule = options.allrules.future;
        if (rule.alertText2) return rule.alertText + methods._dateToString(pdate) + rule.alertText2;
        return rule.alertText + methods._dateToString(pdate);
      }
    },

    /**
     * Checks if valid date
     *
     * @param {string} date string
     * @return a bool based on determination of valid date
     */
    _isDate: function _isDate(value) {
      var dateRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/);
      return dateRegEx.test(value);
    },

    /**
     * Checks if valid date time
     *
     * @param {string} date string
     * @return a bool based on determination of valid date time
     */
    _isDateTime: function _isDateTime(value) {
      var dateTimeRegEx = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/);
      return dateTimeRegEx.test(value);
    },
    //Checks if the start date is before the end date
    //returns true if end is later than start
    _dateCompare: function _dateCompare(start, end) {
      return new Date(start.toString()) < new Date(end.toString());
    },

    /**
     * Checks date range
     *
     * @param {jqObject} first field name
     * @param {jqObject} second field name
     * @return an error string if validation failed
     */
    _dateRange: function _dateRange(field, rules, i, options) {
      //are not both populated
      if (!options.firstOfGroup[0].value && options.secondOfGroup[0].value || options.firstOfGroup[0].value && !options.secondOfGroup[0].value) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      } //are not both dates


      if (!methods._isDate(options.firstOfGroup[0].value) || !methods._isDate(options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      } //are both dates but range is off


      if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
    },

    /**
     * Checks date time range
     *
     * @param {jqObject} first field name
     * @param {jqObject} second field name
     * @return an error string if validation failed
     */
    _dateTimeRange: function _dateTimeRange(field, rules, i, options) {
      //are not both populated
      if (!options.firstOfGroup[0].value && options.secondOfGroup[0].value || options.firstOfGroup[0].value && !options.secondOfGroup[0].value) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      } //are not both dates


      if (!methods._isDateTime(options.firstOfGroup[0].value) || !methods._isDateTime(options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      } //are both dates but range is off


      if (!methods._dateCompare(options.firstOfGroup[0].value, options.secondOfGroup[0].value)) {
        return options.allrules[rules[i]].alertText + options.allrules[rules[i]].alertText2;
      }
    },

    /**
     * Max number of checkbox selected
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _maxCheckbox: function _maxCheckbox(form, field, rules, i, options) {
      var nbCheck = rules[i + 1];
      var groupname = field.attr("name");
      var groupSize = form.find("input[name='" + groupname + "']:checked").length;

      if (groupSize > nbCheck) {
        options.showArrow = false;
        if (options.allrules.maxCheckbox.alertText2) return options.allrules.maxCheckbox.alertText + " " + nbCheck + " " + options.allrules.maxCheckbox.alertText2;
        return options.allrules.maxCheckbox.alertText;
      }
    },

    /**
     * Min number of checkbox selected
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _minCheckbox: function _minCheckbox(form, field, rules, i, options) {
      var nbCheck = rules[i + 1];
      var groupname = field.attr("name");
      var groupSize = form.find("input[name='" + groupname + "']:checked").length;

      if (groupSize < nbCheck) {
        options.showArrow = false;
        return options.allrules.minCheckbox.alertText + " " + nbCheck + " " + options.allrules.minCheckbox.alertText2;
      }
    },

    /**
     * Checks that it is a valid credit card number according to the
     * Luhn checksum algorithm.
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return an error string if validation failed
     */
    _creditCard: function _creditCard(field, rules, i, options) {
      //spaces and dashes may be valid characters, but must be stripped to calculate the checksum.
      var valid = false,
          cardNumber = field.val().replace(/ +/g, '').replace(/-+/g, '');
      var numDigits = cardNumber.length;

      if (numDigits >= 14 && numDigits <= 16 && parseInt(cardNumber) > 0) {
        var sum = 0,
            i = numDigits - 1,
            pos = 1,
            digit,
            luhn = new String();

        do {
          digit = parseInt(cardNumber.charAt(i));
          luhn += pos++ % 2 == 0 ? digit * 2 : digit;
        } while (--i >= 0);

        for (i = 0; i < luhn.length; i++) {
          sum += parseInt(luhn.charAt(i));
        }

        valid = sum % 10 == 0;
      }

      if (!valid) return options.allrules.creditCard.alertText;
    },

    /**
     * Ajax field validation
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     *            user options
     * @return nothing! the ajax validator handles the prompts itself
     */
    _ajax: function _ajax(field, rules, i, options) {
      var errorSelector = rules[i + 1];
      var rule = options.allrules[errorSelector];
      var extraData = rule.extraData;
      var extraDataDynamic = rule.extraDataDynamic;
      var data = {
        "fieldId": field.attr("id"),
        "fieldValue": field.val()
      };

      if (_typeof(extraData) === "object") {
        $.extend(data, extraData);
      } else if (typeof extraData === "string") {
        var tempData = extraData.split("&");

        for (var i = 0; i < tempData.length; i++) {
          var values = tempData[i].split("=");

          if (values[0] && values[0]) {
            data[values[0]] = values[1];
          }
        }
      }

      if (extraDataDynamic) {
        var tmpData = [];
        var domIds = String(extraDataDynamic).split(",");

        for (var i = 0; i < domIds.length; i++) {
          var id = domIds[i];

          if ($(id).length) {
            var inputValue = field.closest("form, .validationEngineContainer").find(id).val();
            var keyValue = id.replace('#', '') + '=' + escape(inputValue);
            data[id.replace('#', '')] = inputValue;
          }
        }
      } // If a field change event triggered this we want to clear the cache for this ID


      if (options.eventTrigger == "field") {
        delete options.ajaxValidCache[field.attr("id")];
      } // If there is an error or if the the field is already validated, do not re-execute AJAX


      if (!options.isError && !methods._checkAjaxFieldStatus(field.attr("id"), options)) {
        $.ajax({
          type: options.ajaxFormValidationMethod,
          url: rule.url,
          cache: false,
          dataType: "json",
          data: data,
          field: field,
          rule: rule,
          methods: methods,
          options: options,
          beforeSend: function beforeSend() {},
          error: function error(data, transport) {
            if (options.onFailure) {
              options.onFailure(data, transport);
            } else {
              methods._ajaxError(data, transport);
            }
          },
          success: function success(json) {
            // asynchronously called on success, data is the json answer from the server
            var errorFieldId = json[0]; //var errorField = $($("#" + errorFieldId)[0]);

            var errorField = $("#" + errorFieldId).eq(0); // make sure we found the element

            if (errorField.length == 1) {
              var status = json[1]; // read the optional msg from the server

              var msg = json[2];

              if (!status) {
                // Houston we got a problem - display an red prompt
                options.ajaxValidCache[errorFieldId] = false;
                options.isError = true; // resolve the msg prompt

                if (msg) {
                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertText;

                    if (txt) {
                      msg = txt;
                    }
                  }
                } else msg = rule.alertText;

                if (options.showPrompts) methods._showPrompt(errorField, msg, "", true, options);
              } else {
                options.ajaxValidCache[errorFieldId] = true; // resolves the msg prompt

                if (msg) {
                  if (options.allrules[msg]) {
                    var txt = options.allrules[msg].alertTextOk;

                    if (txt) {
                      msg = txt;
                    }
                  }
                } else msg = rule.alertTextOk;

                if (options.showPrompts) {
                  // see if we should display a green prompt
                  if (msg) methods._showPrompt(errorField, msg, "pass", true, options);else methods._closePrompt(errorField);
                } // If a submit form triggered this, we want to re-submit the form


                if (options.eventTrigger == "submit") field.closest("form").submit();
              }
            }

            errorField.trigger("jqv.field.result", [errorField, options.isError, msg]);
          }
        });
        return rule.alertTextLoad;
      }
    },

    /**
     * Common method to handle ajax errors
     *
     * @param {Object} data
     * @param {Object} transport
     */
    _ajaxError: function _ajaxError(data, transport) {
      if (data.status == 0 && transport == null) alert("The page is not served from a server! ajax call failed");else if (typeof console != "undefined") console.log("Ajax error: " + data.status + " " + transport);
    },

    /**
     * date -> string
     *
     * @param {Object} date
     */
    _dateToString: function _dateToString(date) {
      return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    },

    /**
     * Parses an ISO date
     * @param {String} d
     */
    _parseDate: function _parseDate(d) {
      var dateParts = d.split("-");
      if (dateParts == d) dateParts = d.split("/");

      if (dateParts == d) {
        dateParts = d.split(".");
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      }

      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    },

    /**
     * Builds or updates a prompt with the given information
     *
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _showPrompt: function _showPrompt(field, promptText, type, ajaxed, options, ajaxform) {
      //Check if we need to adjust what element to show the prompt on
      if (field.data('jqv-prompt-at') instanceof jQuery) {
        field = field.data('jqv-prompt-at');
      } else if (field.data('jqv-prompt-at')) {
        field = $(field.data('jqv-prompt-at'));
      }

      var prompt = methods._getPrompt(field); // The ajax submit errors are not see has an error in the form,
      // When the form errors are returned, the engine see 2 bubbles, but those are ebing closed by the engine at the same time
      // Because no error was found befor submitting


      if (ajaxform) prompt = false; // Check that there is indded text

      if ($.trim(promptText)) {
        if (prompt) methods._updatePrompt(field, prompt, promptText, type, ajaxed, options);else methods._buildPrompt(field, promptText, type, ajaxed, options);
      }
    },

    /**
     * Builds and shades a prompt for the given field.
     *
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _buildPrompt: function _buildPrompt(field, promptText, type, ajaxed, options) {
      // create the prompt
      var prompt = $('<div>');
      prompt.addClass(methods._getClassName(field.attr("id")) + "formError"); // add a class name to identify the parent form of the prompt

      prompt.addClass("parentForm" + methods._getClassName(field.closest('form, .validationEngineContainer').attr("id")));
      prompt.addClass("formError");

      switch (type) {
        case "pass":
          prompt.addClass("greenPopup");
          break;

        case "load":
          prompt.addClass("blackPopup");
          break;

        default:
        /* it has error  */
        //alert("unknown popup type:"+type);

      }

      if (ajaxed) prompt.addClass("ajaxed"); // create the prompt content

      var promptContent = $('<div>').addClass("formErrorContent").html(promptText).appendTo(prompt); // determine position type

      var positionType = field.data("promptPosition") || options.promptPosition; // create the css arrow pointing at the field
      // note that there is no triangle on max-checkbox and radio

      if (options.showArrow) {
        var arrow = $('<div>').addClass("formErrorArrow"); //prompt positioning adjustment support. Usage: positionType:Xshift,Yshift (for ex.: bottomLeft:+20 or bottomLeft:-20,+10)

        if (typeof positionType == 'string') {
          var pos = positionType.indexOf(":");
          if (pos != -1) positionType = positionType.substring(0, pos);
        }

        switch (positionType) {
          case "bottomLeft":
          case "bottomRight":
            prompt.find(".formErrorContent").before(arrow);
            arrow.addClass("formErrorArrowBottom").html('<div class="line1"><!-- --></div><div class="line2"><!-- --></div><div class="line3"><!-- --></div><div class="line4"><!-- --></div><div class="line5"><!-- --></div><div class="line6"><!-- --></div><div class="line7"><!-- --></div><div class="line8"><!-- --></div><div class="line9"><!-- --></div><div class="line10"><!-- --></div>');
            break;

          case "topLeft":
          case "topRight":
            arrow.html('<div class="line10"><!-- --></div><div class="line9"><!-- --></div><div class="line8"><!-- --></div><div class="line7"><!-- --></div><div class="line6"><!-- --></div><div class="line5"><!-- --></div><div class="line4"><!-- --></div><div class="line3"><!-- --></div><div class="line2"><!-- --></div><div class="line1"><!-- --></div>');
            prompt.append(arrow);
            break;
        }
      } // Add custom prompt class


      if (options.addPromptClass) prompt.addClass(options.addPromptClass); // Add custom prompt class defined in element

      var requiredOverride = field.attr('data-required-class');

      if (requiredOverride !== undefined) {
        prompt.addClass(requiredOverride);
      } else {
        if (options.prettySelect) {
          if ($('#' + field.attr('id')).next().is('select')) {
            var prettyOverrideClass = $('#' + field.attr('id').substr(options.usePrefix.length).substring(options.useSuffix.length)).attr('data-required-class');

            if (prettyOverrideClass !== undefined) {
              prompt.addClass(prettyOverrideClass);
            }
          }
        }
      }

      prompt.css({
        "opacity": 0
      });

      if (positionType === 'inline') {
        prompt.addClass("inline");

        if (typeof field.attr('data-prompt-target') !== 'undefined' && $('#' + field.attr('data-prompt-target')).length > 0) {
          prompt.appendTo($('#' + field.attr('data-prompt-target')));
        } else {
          field.after(prompt);
        }
      } else {
        field.before(prompt);
      }

      var pos = methods._calculatePosition(field, prompt, options); // Support RTL layouts by @yasser_lotfy ( Yasser Lotfy )


      if ($('body').hasClass('rtl')) {
        prompt.css({
          'position': positionType === 'inline' ? 'relative' : 'absolute',
          "top": pos.callerTopPosition,
          "left": "initial",
          "right": pos.callerleftPosition,
          "marginTop": pos.marginTopSize,
          "opacity": 0
        }).data("callerField", field);
      } else {
        prompt.css({
          'position': positionType === 'inline' ? 'relative' : 'absolute',
          "top": pos.callerTopPosition,
          "left": pos.callerleftPosition,
          "right": "initial",
          "marginTop": pos.marginTopSize,
          "opacity": 0
        }).data("callerField", field);
      }

      if (options.autoHidePrompt) {
        setTimeout(function () {
          prompt.animate({
            "opacity": 0
          }, function () {
            prompt.closest('.formError').remove();
          });
        }, options.autoHideDelay);
      }

      return prompt.animate({
        "opacity": 0.87
      });
    },

    /**
     * Updates the prompt text field - the field for which the prompt
     * @param {jqObject} field
     * @param {String} promptText html text to display type
     * @param {String} type the type of bubble: 'pass' (green), 'load' (black) anything else (red)
     * @param {boolean} ajaxed - use to mark fields than being validated with ajax
     * @param {Map} options user options
     */
    _updatePrompt: function _updatePrompt(field, prompt, promptText, type, ajaxed, options, noAnimation) {
      if (prompt) {
        if (typeof type !== "undefined") {
          if (type == "pass") prompt.addClass("greenPopup");else prompt.removeClass("greenPopup");
          if (type == "load") prompt.addClass("blackPopup");else prompt.removeClass("blackPopup");
        }

        if (ajaxed) prompt.addClass("ajaxed");else prompt.removeClass("ajaxed");
        prompt.find(".formErrorContent").html(promptText);

        var pos = methods._calculatePosition(field, prompt, options); // Support RTL layouts by @yasser_lotfy ( Yasser Lotfy )


        if ($('body').hasClass('rtl')) {
          var css = {
            "top": pos.callerTopPosition,
            "left": "initial",
            "right": pos.callerleftPosition,
            "marginTop": pos.marginTopSize,
            "opacity": 0.87
          };
        } else {
          var css = {
            "top": pos.callerTopPosition,
            "left": pos.callerleftPosition,
            "right": "initial",
            "marginTop": pos.marginTopSize,
            "opacity": 0.87
          };
        }

        prompt.css({
          "opacity": 0,
          "display": "block"
        });
        if (noAnimation) prompt.css(css);else prompt.animate(css);
      }
    },

    /**
     * Closes the prompt associated with the given field
     *
     * @param {jqObject}
     *            field
     */
    _closePrompt: function _closePrompt(field) {
      var prompt = methods._getPrompt(field);

      if (prompt) prompt.fadeTo("fast", 0, function () {
        prompt.closest('.formError').remove();
      });
    },
    closePrompt: function closePrompt(field) {
      return methods._closePrompt(field);
    },

    /**
     * Returns the error prompt matching the field if any
     *
     * @param {jqObject}
     *            field
     * @return undefined or the error prompt (jqObject)
     */
    _getPrompt: function _getPrompt(field) {
      var formId = $(field).closest('form, .validationEngineContainer').attr('id');
      var className = methods._getClassName(field.attr("id")) + "formError";
      var match = $("." + methods._escapeExpression(className) + '.parentForm' + methods._getClassName(formId))[0];
      if (match) return $(match);
    },

    /**
     * Returns the escapade classname
     *
     * @param {selector}
     *            className
     */
    _escapeExpression: function _escapeExpression(selector) {
      return selector.replace(/([#;&,\.\+\*\~':"\!\^$\[\]\(\)=>\|])/g, "\\$1");
    },

    /**
     * returns true if we are in a RTLed document
     *
     * @param {jqObject} field
     */
    isRTL: function isRTL(field) {
      var $document = $(document);
      var $body = $('body');
      var rtl = field && field.hasClass('rtl') || field && (field.attr('dir') || '').toLowerCase() === 'rtl' || $document.hasClass('rtl') || ($document.attr('dir') || '').toLowerCase() === 'rtl' || $body.hasClass('rtl') || ($body.attr('dir') || '').toLowerCase() === 'rtl';
      return Boolean(rtl);
    },

    /**
     * Calculates prompt position
     *
     * @param {jqObject}
     *            field
     * @param {jqObject}
     *            the prompt
     * @param {Map}
     *            options
     * @return positions
     */
    _calculatePosition: function _calculatePosition(field, promptElmt, options) {
      var promptTopPosition, promptleftPosition, marginTopSize;
      var fieldWidth = field.width();
      var fieldLeft = field.position().left;
      var fieldTop = field.position().top;
      var fieldHeight = field.height();
      var promptHeight = promptElmt.height(); // is the form contained in an overflown container?

      promptTopPosition = promptleftPosition = 0; // compensation for the arrow

      marginTopSize = -promptHeight; //prompt positioning adjustment support
      //now you can adjust prompt position
      //usage: positionType:Xshift,Yshift
      //for example:
      //   bottomLeft:+20 means bottomLeft position shifted by 20 pixels right horizontally
      //   topRight:20, -15 means topRight position shifted by 20 pixels to right and 15 pixels to top
      //You can use +pixels, - pixels. If no sign is provided than + is default.

      var positionType = field.data("promptPosition") || options.promptPosition;
      var shift1 = "";
      var shift2 = "";
      var shiftX = 0;
      var shiftY = 0;

      if (typeof positionType == 'string') {
        //do we have any position adjustments ?
        if (positionType.indexOf(":") != -1) {
          shift1 = positionType.substring(positionType.indexOf(":") + 1);
          positionType = positionType.substring(0, positionType.indexOf(":")); //if any advanced positioning will be needed (percents or something else) - parser should be added here
          //for now we use simple parseInt()
          //do we have second parameter?

          if (shift1.indexOf(",") != -1) {
            shift2 = shift1.substring(shift1.indexOf(",") + 1);
            shift1 = shift1.substring(0, shift1.indexOf(","));
            shiftY = parseInt(shift2);
            if (isNaN(shiftY)) shiftY = 0;
          }

          ;
          shiftX = parseInt(shift1);
          if (isNaN(shift1)) shift1 = 0;
        }

        ;
      }

      ;

      switch (positionType) {
        default:
        case "topRight":
          promptleftPosition += fieldLeft + fieldWidth - 27;
          promptTopPosition += fieldTop;
          break;

        case "topLeft":
          promptTopPosition += fieldTop;
          promptleftPosition += fieldLeft;
          break;

        case "centerRight":
          promptTopPosition = fieldTop + 4;
          marginTopSize = 0;
          promptleftPosition = fieldLeft + field.outerWidth(true) + 5;
          break;

        case "centerLeft":
          promptleftPosition = fieldLeft - (promptElmt.width() + 2);
          promptTopPosition = fieldTop + 4;
          marginTopSize = 0;
          break;

        case "bottomLeft":
          promptTopPosition = fieldTop + field.height() + 5;
          marginTopSize = 0;
          promptleftPosition = fieldLeft;
          break;

        case "bottomRight":
          promptleftPosition = fieldLeft + fieldWidth - 27;
          promptTopPosition = fieldTop + field.height() + 5;
          marginTopSize = 0;
          break;

        case "inline":
          promptleftPosition = 0;
          promptTopPosition = 0;
          marginTopSize = 0;
      }

      ; //apply adjusments if any

      promptleftPosition += shiftX;
      promptTopPosition += shiftY;
      return {
        "callerTopPosition": promptTopPosition + "px",
        "callerleftPosition": promptleftPosition + "px",
        "marginTopSize": marginTopSize + "px"
      };
    },

    /**
     * Saves the user options and variables in the form.data
     *
     * @param {jqObject}
     *            form - the form where the user option should be saved
     * @param {Map}
     *            options - the user options
     * @return the user options (extended from the defaults)
     */
    _saveOptions: function _saveOptions(form, options) {
      // is there a language localisation ?
      if ($.validationEngineLanguage) var allRules = $.validationEngineLanguage.allRules;else $.error("jQuery.validationEngine rules are not loaded, plz add localization files to the page"); // --- Internals DO NOT TOUCH or OVERLOAD ---
      // validation rules and i18

      $.validationEngine.defaults.allrules = allRules;
      var userOptions = $.extend(true, {}, $.validationEngine.defaults, options);
      form.data('jqv', userOptions);
      return userOptions;
    },

    /**
     * Removes forbidden characters from class name
     * @param {String} className
     */
    _getClassName: function _getClassName(className) {
      if (className) return className.replace(/:/g, "_").replace(/\./g, "_");
    },

    /**
     * Escape special character for jQuery selector
     * http://totaldev.com/content/escaping-characters-get-valid-jquery-id
     * @param {String} selector
     */
    _jqSelector: function _jqSelector(str) {
      return str.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
    },

    /**
     * Conditionally required field
     *
     * @param {jqObject} field
     * @param {Array[String]} rules
     * @param {int} i rules index
     * @param {Map}
     * user options
     * @return an error string if validation failed
     */
    _condRequired: function _condRequired(field, rules, i, options) {
      var idx, dependingField;

      for (idx = i + 1; idx < rules.length; idx++) {
        dependingField = jQuery("#" + rules[idx]).first();
        /* Use _required for determining wether dependingField has a value.
         * There is logic there for handling all field types, and default value; so we won't replicate that here
         * Indicate this special use by setting the last parameter to true so we only validate the dependingField on chackboxes and radio buttons (#462)
         */

        if (dependingField.length && methods._required(dependingField, ["required"], 0, options, true) == undefined) {
          /* We now know any of the depending fields has a value,
           * so we can validate this field as per normal required code
           */
          return methods._required(field, ["required"], 0, options);
        }
      }
    },
    _submitButtonClick: function _submitButtonClick(event) {
      var button = $(this);
      var form = button.closest('form, .validationEngineContainer');
      form.data("jqv_submitButton", button.attr("id"));
    }
  };
  /**
   * Plugin entry point.
   * You may pass an action as a parameter or a list of options.
   * if none, the init and attach methods are being called.
   * Remember: if you pass options, the attached method is NOT called automatically
   *
   * @param {String}
   *            method (optional) action
   */

  $.fn.validationEngine = function (method) {
    var form = $(this);
    if (!form[0]) return form; // stop here if the form does not exist

    if (typeof method == 'string' && method.charAt(0) != '_' && methods[method]) {
      // make sure init is called once
      if (method != "showPrompt" && method != "hide" && method != "hideAll") methods.init.apply(form);
      return methods[method].apply(form, Array.prototype.slice.call(arguments, 1));
    } else if (_typeof(method) == 'object' || !method) {
      // default constructor with or without arguments
      methods.init.apply(form, arguments);
      return methods.attach.apply(form);
    } else {
      $.error('Method ' + method + ' does not exist in jQuery.validationEngine');
    }
  }; // LEAK GLOBAL OPTIONS


  $.validationEngine = {
    fieldIdCounter: 0,
    defaults: {
      // Name of the event triggering field validation
      validationEventTrigger: "blur",
      // Automatically scroll viewport to the first error
      scroll: true,
      // Focus on the first input
      focusFirstField: true,
      // Show prompts, set to false to disable prompts
      showPrompts: true,
      // Should we attempt to validate non-visible input fields contained in the form? (Useful in cases of tabbed containers, e.g. jQuery-UI tabs)
      validateNonVisibleFields: false,
      // ignore the validation for fields with this specific class (Useful in cases of tabbed containers AND hidden fields we don't want to validate)
      ignoreFieldsWithClass: 'ignoreMe',
      // Opening box position, possible locations are: topLeft,
      // topRight, bottomLeft, centerRight, bottomRight, inline
      // inline gets inserted after the validated field or into an element specified in data-prompt-target
      promptPosition: "topRight",
      bindMethod: "bind",
      // internal, automatically set to true when it parse a _ajax rule
      inlineAjax: false,
      // if set to true, the form data is sent asynchronously via ajax to the form.action url (get)
      ajaxFormValidation: false,
      // The url to send the submit ajax validation (default to action)
      ajaxFormValidationURL: false,
      // HTTP method used for ajax validation
      ajaxFormValidationMethod: 'get',
      // Ajax form validation callback method: boolean onComplete(form, status, errors, options)
      // retuns false if the form.submit event needs to be canceled.
      onAjaxFormComplete: $.noop,
      // called right before the ajax call, may return false to cancel
      onBeforeAjaxFormValidation: $.noop,
      // Stops form from submitting and execute function assiciated with it
      onValidationComplete: false,
      // Used when you have a form fields too close and the errors messages are on top of other disturbing viewing messages
      doNotShowAllErrosOnSubmit: false,
      // Object where you store custom messages to override the default error messages
      custom_error_messages: {},
      // true if you want to validate the input fields on blur event
      binded: true,
      // set to true if you want to validate the input fields on blur only if the field it's not empty
      notEmpty: false,
      // set to true, when the prompt arrow needs to be displayed
      showArrow: true,
      // set to false, determines if the prompt arrow should be displayed when validating
      // checkboxes and radio buttons
      showArrowOnRadioAndCheckbox: false,
      // did one of the validation fail ? kept global to stop further ajax validations
      isError: false,
      // Limit how many displayed errors a field can have
      maxErrorsPerField: false,
      // Caches field validation status, typically only bad status are created.
      // the array is used during ajax form validation to detect issues early and prevent an expensive submit
      ajaxValidCache: {},
      // Auto update prompt position after window resize
      autoPositionUpdate: false,
      InvalidFields: [],
      onFieldSuccess: false,
      onFieldFailure: false,
      onSuccess: false,
      onFailure: false,
      validateAttribute: "class",
      addSuccessCssClassToField: "",
      addFailureCssClassToField: "",
      // Auto-hide prompt
      autoHidePrompt: false,
      // Delay before auto-hide
      autoHideDelay: 10000,
      // Fade out duration while hiding the validations
      fadeDuration: 300,
      // Use Prettify select library
      prettySelect: false,
      // Add css class on prompt
      addPromptClass: "",
      // Custom ID uses prefix
      usePrefix: "",
      // Custom ID uses suffix
      useSuffix: "",
      // Only show one message per error prompt
      showOneMessage: false
    }
  };
  $(function () {
    $.validationEngine.defaults.promptPosition = methods.isRTL() ? 'topLeft' : "topRight";
  });
})(jQuery);

;

(function ($) {
  //validate options
  JS_FORMS._validation_options = {};
  JS_FORMS._callbacks = []; //Create a validation function

  JS_FORMS.validation = function (selector, caller_id) {
    //find the form element
    $(selector).find(JS_FORMS.input_element_wrapper[caller_id]).each(function () {
      //default validations vars
      _default_val = '';
      _validation_default = []; //custom validations vars

      _custom_val = '';
      _validation_custom = []; //minimum validations vars

      _min_val = '';
      _validation_min = ''; //maximum validations vars

      _max_val = '';
      _validation_max = ''; //minimum size validations vars

      _min_size_val = '';
      _validation_min_size = ''; //maximum size validations vars

      _max_size_val = '';
      _validation_max_size = ''; //minimum checkbox size 

      _min_checkbox_val = '';
      _validation_min_checkbox = ''; //maximum checkbox size

      _max_checkbox_val = '';
      _validation_max_checkbox = ''; //equal vars

      _equals_val = '';
      _validation_equals = ''; //condition vars

      _condition_val = '';
      _validation_condition = ''; //Past vars

      _past_val = '';
      _validation_past = ''; //Future vars

      _future_val = '';
      _validation_future = ''; //------------------------------------------------------------------------

      _id = '';
      _group_name = [];
      _validation_type = '';
      _combined_rules = []; //cache the input elem

      $_input = $(this).find('input, textarea, select'); //------------------------------------------------------------------------
      //ADD THE VALIDATION CLASSES
      //TO THE ELEMENTS
      //------------------------------------------------------------------------

      if (JS_FORMS.add_class[caller_id] && $_input.attr('class') != undefined) {
        // add groups required
        var group_regex = new RegExp(JS_FORMS.group_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var group_name = $_input.attr('class').match(group_regex);

        if (group_name != '' && group_name != null) {
          //set validation type
          _validation_type = 'group'; //add the validation

          _validation_default.push('groupRequired');

          _group_name.push(group_name[0].replace(JS_FORMS.group_class[caller_id] + ':', '')); //remove the class


          $_input.removeClass(group_name[0]); // normal line required
        } else if ($(this).hasClass(JS_FORMS.require_class[caller_id]) || $_input.hasClass(JS_FORMS.require_class[caller_id])) {
          //set validation type
          _validation_type = 'single'; //add rule

          _validation_default.push('required');

          $_input.removeClass(JS_FORMS.require_class[caller_id]);
        } // email validation


        if ($(this).hasClass(JS_FORMS.email_class[caller_id]) || $_input.hasClass(JS_FORMS.email_class[caller_id])) {
          _validation_custom.push('email');

          $_input.removeClass(JS_FORMS.email_class[caller_id]);
        } // integer validation


        if ($(this).hasClass(JS_FORMS.integer_class[caller_id]) || $_input.hasClass(JS_FORMS.integer_class[caller_id])) {
          _validation_custom.push('integer');

          $_input.removeClass(JS_FORMS.integer_class[caller_id]);
        } // number validation


        if ($(this).hasClass(JS_FORMS.number_class[caller_id]) || $_input.hasClass(JS_FORMS.number_class[caller_id])) {
          _validation_custom.push('number');

          $_input.removeClass(JS_FORMS.number_class[caller_id]);
        } // phone validation


        if ($(this).hasClass(JS_FORMS.phone_class[caller_id]) || $_input.hasClass(JS_FORMS.phone_class[caller_id])) {
          _validation_custom.push('phone');

          $_input.removeClass(JS_FORMS.phone_class[caller_id]);
        } // url validation


        if ($(this).hasClass(JS_FORMS.url_class[caller_id]) || $_input.hasClass(JS_FORMS.url_class[caller_id])) {
          _validation_custom.push('url');

          $_input.removeClass(JS_FORMS.url_class[caller_id]);
        } // date validation


        if ($(this).hasClass(JS_FORMS.date_class[caller_id]) || $_input.hasClass(JS_FORMS.date_class[caller_id])) {
          _validation_custom.push('date');

          $_input.removeClass(JS_FORMS.date_class[caller_id]);
        } // ipv4 validation


        if ($(this).hasClass(JS_FORMS.ipv4_class[caller_id]) || $_input.hasClass(JS_FORMS.ipv4_class[caller_id])) {
          _validation_custom.push('ipv4');

          $_input.removeClass(JS_FORMS.ipv4_class[caller_id]);
        } // Creditcard validation


        if ($(this).hasClass(JS_FORMS.creditcard_class[caller_id]) || $_input.hasClass(JS_FORMS.creditcard_class[caller_id])) {
          _combined_rules.push('creditCard');

          $_input.removeClass(JS_FORMS.creditcard_class[caller_id]);
        } // Equals validation


        var equals_regex = new RegExp(JS_FORMS.equals_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var equals_name = $_input.attr('class').match(equals_regex);

        if (equals_name != '' && equals_name != null) {
          _validation_equals = equals_name[0].replace(JS_FORMS.equals_class[caller_id] + ':', '');
          $_input.removeClass(equals_name[0]);
        } // Past validation


        var past_regex = new RegExp(JS_FORMS.past_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var past_name = $_input.attr('class').match(past_regex);

        if (past_name != '' && past_name != null) {
          _validation_past = past_name[0].replace(JS_FORMS.past_class[caller_id] + ':', '');
          $_input.removeClass(past_name[0]);
        } // Past validation


        var future_regex = new RegExp(JS_FORMS.future_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var future_name = $_input.attr('class').match(future_regex);

        if (future_name != '' && future_name != null) {
          _validation_future = future_name[0].replace(JS_FORMS.future_class[caller_id] + ':', '');
          $_input.removeClass(future_name[0]);
        } // condition validation


        var condition_regex = new RegExp(JS_FORMS.condition_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var condition_name = $_input.attr('class').match(condition_regex);

        if (condition_name != '' && condition_name != null) {
          _validation_condition = condition_name[0].replace(JS_FORMS.condition_class[caller_id] + ':', '');
          $_input.removeClass(condition_name[0]);
        } // MIN validation


        var min_regex = new RegExp(JS_FORMS.min_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var min_name = $_input.attr('class').match(min_regex);

        if (min_name != '' && min_name != null) {
          _validation_min = min_name[0].replace(JS_FORMS.min_class[caller_id] + ':', '');
          $_input.removeClass(min_name[0]);
        } // MAX validation


        var max_regex = new RegExp(JS_FORMS.max_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var max_name = $_input.attr('class').match(max_regex);

        if (max_name != '' && max_name != null) {
          _validation_max = max_name[0].replace(JS_FORMS.max_class[caller_id] + ':', '');
          $_input.removeClass(max_name[0]);
        } // MIN validation


        var min_size_regex = new RegExp(JS_FORMS.min_size_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var min_size_name = $_input.attr('class').match(min_size_regex);

        if (min_size_name != '' && min_size_name != null) {
          _validation_min_size = min_size_name[0].replace(JS_FORMS.min_size_class[caller_id] + ':', '');
          $_input.removeClass(min_size_name[0]);
        } // MAX validation


        var max_size_regex = new RegExp(JS_FORMS.max_size_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var max_size_name = $_input.attr('class').match(max_size_regex);

        if (max_size_name != '' && max_size_name != null) {
          _validation_max_size = max_size_name[0].replace(JS_FORMS.max_size_class[caller_id] + ':', '');
          $_input.removeClass(max_size_name[0]);
        } // MIN checkbox validation


        var min_checkbox_regex = new RegExp(JS_FORMS.min_checkbox_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var min_checkbox_name = $_input.attr('class').match(min_checkbox_regex);

        if (min_checkbox_name != '' && min_checkbox_name != null) {
          _validation_min_checkbox = min_checkbox_name[0].replace(JS_FORMS.min_checkbox_class[caller_id] + ':', '');
          $_input.removeClass(min_checkbox_name[0]);
        } // MIN checkbox validation


        var max_checkbox_regex = new RegExp(JS_FORMS.max_checkbox_class[caller_id] + ':[a-zA-Z0-9_-]*', 'g');
        var max_checkbox_name = $_input.attr('class').match(max_checkbox_regex);

        if (max_checkbox_name != '' && max_checkbox_name != null) {
          _validation_max_checkbox = max_checkbox_name[0].replace(JS_FORMS.max_checkbox_class[caller_id] + ':', '');
          $_input.removeClass(max_checkbox_name[0]);
        }
      } //------------------------------------------------------------------------
      //END OF THE VALIDATIONS CLASSES
      //WHO ARE APPEND TO INPUT OBJECTS
      //------------------------------------------------------------------------
      //join all default validation to string


      if (_validation_default.length > 0) {
        _default_val = _validation_default.join(','); //is group validation, show also the groupname

        if (_validation_type == 'group') {
          _default_val += '[' + _group_name.join(',') + ']';
        }

        _combined_rules.push(_default_val);
      } //join all custom validation to string


      if (_validation_custom.length > 0) {
        _custom_val = 'custom[' + _validation_custom.join(',') + ']';

        _combined_rules.push(_custom_val);
      } //join all Minimum validation to string


      if (_validation_min != '') {
        _min_val = 'min[' + _validation_min + ']';

        _combined_rules.push(_min_val);
      } //join all maximum validation to string


      if (_validation_max != '') {
        _max_val = 'max[' + _validation_max + ']';

        _combined_rules.push(_max_val);
      } //join all Minimum size validation to string


      if (_validation_min_size != '') {
        _min_size_val = 'minSize[' + _validation_min_size + ']';

        _combined_rules.push(_min_size_val);
      } //join all maximum size validation to string


      if (_validation_max_size != '') {
        _max_size_val = 'maxSize[' + _validation_max_size + ']';

        _combined_rules.push(_max_size_val);
      } //join all equals validation to string


      if (_validation_equals != '') {
        _equals_val = 'equals[' + _validation_equals + ']';

        _combined_rules.push(_equals_val);
      } //join all condition validation to string


      if (_validation_condition != '') {
        _condition_val = 'condRequired[' + _validation_condition + ']';

        _combined_rules.push(_condition_val);
      } //join all maximum checkbox size validation to string


      if (_validation_min_checkbox != '') {
        _min_checkbox_val = 'minCheckbox[' + _validation_min_checkbox + ']';

        _combined_rules.push(_min_checkbox_val);
      } //join all maximum checkbox size validation to string


      if (_validation_max_checkbox != '') {
        _max_checkbox_val = 'maxCheckbox[' + _validation_max_checkbox + ']';

        _combined_rules.push(_max_checkbox_val);
      } //join all past validation to string


      if (_validation_past != '') {
        _past_val = 'past[' + _validation_past + ']';

        _combined_rules.push(_past_val);
      } //join all future validation to string


      if (_validation_future != '') {
        _future_val = 'future[' + _validation_future + ']';

        _combined_rules.push(_future_val);
      } //set the id


      _id = $(this).find('input, select, textarea').attr('name'); //add the class

      if (_combined_rules.length > 0) {
        //$(this).find('input, select, textarea').addClass('validate[' +_combined_rules.join(',')+ ']');
        $(this).find('input, select, textarea').attr('data-validation-engine', 'validate[' + _combined_rules.join(',') + ']');
      } //add ID


      $(this).find('input, select, textarea').attr('id', _id);
    }); //detach for safe

    if (typeof $(selector).validationEngine != 'undefined') {
      $(selector).validationEngine('detach');
    } //set the validation options


    $.extend(JS_FORMS._validation_options, {
      promptPosition: JS_FORMS.promt_position[caller_id],
      scroll: JS_FORMS.scroll[caller_id],
      autoHidePrompt: JS_FORMS.auto_hide_prompt[caller_id],
      autoHideDelay: JS_FORMS.auto_hide_delay[caller_id],
      binded: JS_FORMS.binded[caller_id],
      showOneMessage: JS_FORMS.show_one_message[caller_id],
      ajaxFormValidation: JS_FORMS.ajax_form_validation[caller_id],
      ajaxFormValidationURL: JS_FORMS.ajax_form_validation_url[caller_id],
      ajaxFormValidationMethod: JS_FORMS.ajax_form_validation_method[caller_id]
    }); //set the callback functions

    for (var key in JS_FORMS._callbacks[caller_id]) {
      var obj = {};
      obj[key] = JS_FORMS._callbacks[caller_id][key];
      $.extend(JS_FORMS._validation_options, obj);
    }

    ; //run the validation

    $(selector).validationEngine('attach', JS_FORMS._validation_options);
  }; //add callback functions


  JS_FORMS.addCallbackEvent = function (type, n, callback) {
    if (typeof callback == 'function' && n != '' && type != '') {
      //create an array
      if (!jQuery.isArray(JS_FORMS._callbacks[n])) {
        JS_FORMS._callbacks[n] = [];
      }

      JS_FORMS._callbacks[n][type] = callback;
    }
  }; //call all validation


  JS_FORMS.init = function () {
    if (JS_FORMS.selector != '') {
      jQuery.each(JS_FORMS.selector, function (key, val) {
        JS_FORMS.validation(JS_FORMS.selector[key], key);
      });
    }
  };

  JS_FORMS.refresh = function () {
    JS_FORMS.init();
  }; //loop over the form that have to be validated


  $(window).ready(function () {
    JS_FORMS.init();
  });
})(jQuery);